<template>
  <div class="recommend-all-container" ref="mainContainer">
    
    <!-- 1. STICKY GLASS HEADER -->
    <header class="glass-header">
      <div class="header-inner">
        <!-- District/Filter Trigger -->
        <div class="filter-trigger-wrapper" ref="filterDropdown">
            <button 
            class="filter-pill-btn magnetic-btn" 
            @click="toggleFilterDropdown" 
            :class="{ active: isFilterDropdownOpen }"
            @mouseenter="handleButtonHover"
            @mouseleave="handleButtonLeave"
          >
            <span class="icon-box"><i class="el-icon-location-outline"></i></span>
            <span class="btn-text">
              {{ locationFilterSummary }}
            </span>
            <i class="el-icon-arrow-down arrow" :class="{ rotate: isFilterDropdownOpen }"></i>
            <span class="btn-ripple"></span>
          </button>

          <!-- Dropdown Backdrop Overlay (Mobile) -->
          <transition name="fade">
            <div 
              v-if="isFilterDropdownOpen && isMobile" 
              class="dropdown-backdrop" 
              @click="isFilterDropdownOpen = false"
            ></div>
          </transition>
          
          <!-- Dropdown Menu (Premium Float) -->
          <transition name="dropdown-expand">
            <div v-if="isFilterDropdownOpen" class="premium-dropdown glass-panel">
              <div class="dropdown-header-mobile" v-if="isMobile">
                <h3>{{ $t('pages.recommendHouse.select_location_9fa73f5') }}</h3>
                <button @click="isFilterDropdownOpen = false">&times;</button>
          </div>

              <div class="col-layout">
  <!-- Region Column -->
                <div class="col">
                  <div class="col-label">{{ $t('pages.recommendHouse.region_0f21717') }}</div>
                  <div 
                    v-for="region in regions" 
                    :key="region" 
                    class="list-item"
                    :class="{ active: selectedRegion === region }"
                    @click="selectRegion(region)"
                  >
                    {{ region }}
                    <i class="el-icon-arrow-right" v-if="selectedRegion === region"></i>
    </div>
  </div>

  <!-- District Column -->
                <div class="col" v-if="selectedRegion">
                   <div class="col-label">{{ $t('pages.recommendHouse.district_c0cb139') }}</div>
                   <div 
                    v-for="district in availableDistricts" 
                    :key="district" 
                    class="list-item"
                    :class="{ active: selectedDistrict === district }"
                    @click="selectDistrict(district)"
                  >
                    {{ district }}
                     <i class="el-icon-arrow-right" v-if="selectedDistrict === district"></i>
    </div>
  </div>

  <!-- Area Column -->
                <div class="col" v-if="selectedDistrict">
                   <div class="col-label">{{ $t('pages.recommendHouse.area_2745deb') }}</div>
                   <div 
                    v-for="area in availableAreas" 
                    :key="area" 
                    class="list-item"
                    :class="{ active: isAreaSelected(area) }"
                    @click="selectArea(area)"
                  >
                    {{ area }}
                    <div class="check-circle" v-if="isAreaSelected(area)"></div>
    </div>
  </div>
</div>

              <div v-if="selectedLocations.length" class="selected-locations-chips">
                <span
                  v-for="(loc, idx) in selectedLocations"
                  :key="'sel-loc-' + idx"
                  class="location-chip"
                >
                  {{ locationPickLabel(loc) }}
                  <button type="button" class="chip-remove" @click.stop="removeLocationPick(idx)" :aria-label="$t('pages.recommendHouse.remove_location_d805001')">&times;</button>
                </span>
              </div>
              <div class="dropdown-add-location-row">
                <button type="button" class="add-location-btn" @click.stop="addCurrentLocationToList">
                  {{ $t('pages.recommendHouse.add_to_multi_location_search_e76d666') }}
                </button>
              </div>

              <div class="dropdown-footer">
                <button class="text-btn" @click="resetAdvancedFilters">{{ $t('pages.recommendHouse.reset_44c57ab') }}</button>
                <button class="primary-btn sm" @click="applyAdvancedFilters">{{ $t('pages.recommendHouse.apply_filter_aa3dea2') }}</button>
          </div>
        </div>
          </transition>
      </div>

        <!-- Search Bar with Border Beam -->
        <div class="search-bar-wrapper search-autocomplete-wrap" ref="searchAutocompleteWrap">
          <div class="search-beam-container">
            <div class="beam-border"></div>
            <div class="search-input-group">
              <i class="el-icon-search search-icon"></i>
            <input
              type="text"
              v-model="searchText"
              :placeholder="$t('pages.recommendHouse.search_houses_dorms_locations_248bdb2')"
              autocomplete="off"
              @keydown.enter="search"
              @keydown.down.prevent="focusFirstSuggestion"
              @input="handleSearchInput"
              @focus="onSearchFocus"
            />
              <button class="search-submit-btn" @click="search" :disabled="isLoading">
                <i class="el-icon-loading" v-if="isLoading"></i>
                <span v-else>{{ $t('pages.recommendHouse.search_bce0641') }}</span>
            </button>
          </div>
          </div>
          <transition name="fade">
            <div
              v-if="searchSuggestionsOpen && autocompleteSuggestions.length"
              class="search-suggestions-panel"
              role="listbox"
            >
              <button
                v-for="(item, idx) in autocompleteSuggestions"
                :key="(item.id != null ? item.id : idx) + '-' + idx"
                type="button"
                class="search-suggestion-item"
                role="option"
                @mousedown.prevent="selectAutocompleteSuggestion(item)"
              >
                <span class="suggestion-title">{{ item.name || formatAutocompleteLabel(item) }}</span>
                <span class="suggestion-meta">{{ [item.district, item.area].filter(Boolean).join(' · ') }}</span>
              </button>
            </div>
          </transition>
      </div>

      </div>
    </header>

    <!-- MOBILE FULLSCREEN FILTER OVERLAY - Before main-grid for proper stacking -->
    <div v-if="showFilters && isMobile" class="mobile-filter-overlay">
      <div class="mobile-filter-header">
        <h2>{{ $t('pages.recommendHouse.filters_96e5782') }}</h2>
        <button class="mobile-close-btn" @click="toggleFilters" :aria-label="$t('pages.recommendHouse.close_filters_c2db1e0')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="mobile-filter-content">
        <!-- Provider Filter -->
        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.provider_7ceee3f') }}</label>
          <div class="mobile-radio-grid">
            <div class="mobile-radio-item" :class="{ active: filters.selectedProvider === 'All' }" @click="selectListingProvider('All')">
              <span class="mobile-radio-dot" :class="{ checked: filters.selectedProvider === 'All' }"></span>
              <span>{{ $t('pages.recommendHouse.all_6a72085') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.selectedProvider === 'University' }" @click="selectListingProvider('University')">
              <span class="mobile-radio-dot" :class="{ checked: filters.selectedProvider === 'University' }"></span>
              <span>{{ $t('pages.recommendHouse.university_715432d') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.selectedProvider === 'Agency' }" @click="selectListingProvider('Agency')">
              <span class="mobile-radio-dot" :class="{ checked: filters.selectedProvider === 'Agency' }"></span>
              <span>{{ $t('pages.recommendHouse.agency_5c47e26') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.selectedProvider === 'Private Landlord' }" @click="selectListingProvider('Private Landlord')">
              <span class="mobile-radio-dot" :class="{ checked: filters.selectedProvider === 'Private Landlord' }"></span>
              <span>{{ $t('pages.recommendHouse.private_landlord_e5b909a') }}</span>
            </div>
          </div>
        </div>

        <div class="mobile-filter-card" v-if="filters.selectedProvider === 'University'">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.university_715432d') }}</label>
          <el-select
            v-model="filters.selectedUniversity"
            class="university-filter-select"
            filterable
            clearable
            :placeholder="$t('pages.recommendHouse.select_a_university_80d42c5')"
          >
            <el-option
              v-for="u in universityOptions"
              :key="u.id"
              :label="u.name"
              :value="u.name"
            />
          </el-select>
          <div class="mobile-radio-grid" v-if="filters.selectedUniversity" style="margin-top:10px;">
            <div class="mobile-radio-item" :class="{ active: filters.selectedUniversityScope === 'all' }" @click="filters.selectedUniversityScope = 'all'">
              <span class="mobile-radio-dot" :class="{ checked: filters.selectedUniversityScope === 'all' }"></span>
              <span>{{ $t('pages.recommendHouse.all_6a72085') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.selectedUniversityScope === 'on' }" @click="filters.selectedUniversityScope = 'on'">
              <span class="mobile-radio-dot" :class="{ checked: filters.selectedUniversityScope === 'on' }"></span>
              <span>{{ $t('pages.recommendHouse.on_campus_de78303') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.selectedUniversityScope === 'off' }" @click="filters.selectedUniversityScope = 'off'">
              <span class="mobile-radio-dot" :class="{ checked: filters.selectedUniversityScope === 'off' }"></span>
              <span>{{ $t('pages.recommendHouse.off_campus_6fd4374') }}</span>
            </div>
          </div>
        </div>

        <!-- Bedroom Filter -->
        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.bedroom_f69fecd') }}</label>
          <div class="mobile-radio-grid">
            <div class="mobile-radio-item" :class="{ active: filters.bedroom === 'any' }" @click="filters.bedroom = 'any'">
              <span class="mobile-radio-dot" :class="{ checked: filters.bedroom === 'any' }"></span>
              <span>{{ $t('pages.recommendHouse.any_322444d') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.bedroom === '1 Bed' }" @click="filters.bedroom = '1 Bed'">
              <span class="mobile-radio-dot" :class="{ checked: filters.bedroom === '1 Bed' }"></span>
              <span>{{ $t('pages.recommendHouse.1_bed_fb8e3a4') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.bedroom === 'Bunk bed' }" @click="filters.bedroom = 'Bunk bed'">
              <span class="mobile-radio-dot" :class="{ checked: filters.bedroom === 'Bunk bed' }"></span>
              <span>{{ $t('pages.recommendHouse.bunk_bed_3de27ba') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.bedroom === '+2 Beds' }" @click="filters.bedroom = '+2 Beds'">
              <span class="mobile-radio-dot" :class="{ checked: filters.bedroom === '+2 Beds' }"></span>
              <span>{{ $t('pages.recommendHouse.2_beds_435bff3') }}</span>
            </div>
          </div>
        </div>

        <!-- Room Type Filter -->
        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.room_type_6320f14') }}</label>
          <div class="mobile-radio-grid">
            <div class="mobile-radio-item" :class="{ active: filters.bathroom === 'any' }" @click="filters.bathroom = 'any'">
              <span class="mobile-radio-dot" :class="{ checked: filters.bathroom === 'any' }"></span>
              <span>{{ $t('pages.recommendHouse.any_322444d') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.bathroom === '1' }" @click="filters.bathroom = '1'">
              <span class="mobile-radio-dot" :class="{ checked: filters.bathroom === '1' }"></span>
              <span>{{ $t('pages.recommendHouse.shared_50d0d8d') }}</span>
            </div>
            <div class="mobile-radio-item" :class="{ active: filters.bathroom === '0' }" @click="filters.bathroom = '0'">
              <span class="mobile-radio-dot" :class="{ checked: filters.bathroom === '0' }"></span>
              <span>{{ $t('pages.recommendHouse.personal_40f0732') }}</span>
            </div>
          </div>
        </div>

        <!-- Minimum Roommates -->
        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.min_roommates_bfeb7ec') }}</label>
          <div class="mobile-slider-value">{{ filters.minRoommates === 0 ? 'Any' : filters.minRoommates }}</div>
          <input type="range" min="0" max="10" v-model.number="filters.minRoommates" class="mobile-slider">
        </div>

        <!-- Maximum Roommates -->
        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.max_roommates_27e71b8') }}</label>
          <div class="mobile-slider-value">{{ filters.maxRoommates === 0 ? 'Any' : filters.maxRoommates }}</div>
          <input type="range" min="0" max="10" v-model.number="filters.maxRoommates" class="mobile-slider">
        </div>

        <!-- Minimum Floor -->
        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.min_floor_7336b36') }}</label>
          <div class="mobile-slider-value">{{ filters.minFloor === 0 ? 'Any' : filters.minFloor + '/F' }}</div>
          <input type="range" min="0" max="50" v-model.number="filters.minFloor" class="mobile-slider">
        </div>

        <!-- Maximum Floor -->
        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.max_floor_5363671') }}</label>
          <div class="mobile-slider-value">{{ filters.maxFloor === 0 ? 'Any' : filters.maxFloor + '/F' }}</div>
          <input type="range" min="0" max="50" v-model.number="filters.maxFloor" class="mobile-slider">
        </div>

        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.min_price_f9cc312') }}</label>
          <input v-model.number="filters.minPrice" type="number" min="0" class="mobile-text-input" :placeholder="$t('pages.recommendHouse.any_322444d')" />
        </div>

        <div class="mobile-filter-card">
          <label class="mobile-filter-label">{{ $t('pages.recommendHouse.max_price_de84944') }}</label>
          <input v-model.number="filters.maxPrice" type="number" min="0" class="mobile-text-input" :placeholder="$t('pages.recommendHouse.any_322444d')" />
        </div>
      </div>

      <div class="mobile-filter-footer">
        <button class="mobile-clear-btn" @click="clearFilters">{{ $t('pages.recommendHouse.clear_719ea39') }}</button>
        <button class="mobile-apply-btn" @click="search">{{ $t('pages.recommendHouse.apply_cfea419') }}</button>
      </div>
    </div>

    <!-- 2. MAIN LAYOUT GRID -->
    <div class="main-grid" :class="{ 'filters-hidden': !showDesktopFilters && !isMobile }">
      
      <!-- Filter Backdrop Overlay (Mobile) -->
      <transition name="fade">
        <div 
          v-if="showFilters && isMobile" 
          class="filter-backdrop" 
          @click="toggleFilters"
        ></div>
      </transition>

      <!-- LEFT SIDEBAR: ENHANCED FILTERS (Airbnb-inspired) -->
      <aside class="sidebar glass-panel" :class="{ 'sidebar-hidden': !showDesktopFilters && !isMobile }">
        <!-- Filter Header -->
        <div class="sidebar-header-desktop-enhanced">
          <h3 class="filter-title-main">{{ $t('pages.recommendHouse.filters_96e5782') }}</h3>
        </div>

        <!-- Actions above scroll so Reset/Apply stay visible on desktop -->
        <div class="sidebar-footer-enhanced">
          <button class="filter-action-btn clear-btn" @click="clearFilters">{{ $t('pages.recommendHouse.clear_all_c043160') }}</button>
          <button class="filter-action-btn apply-btn" @click="search">{{ $t('pages.recommendHouse.show_places_9daa640') }}</button>
        </div>

        <div class="filter-scroll-area">
          <!-- Type of Place Filter -->
          <div class="filter-section-enhanced">
            <h4 class="filter-section-title">{{ $t('pages.recommendHouse.provider_7ceee3f') }}</h4>
            <div class="segmented-control">
              <button 
                class="segmented-btn"
                :class="{ active: filters.selectedProvider === 'All' }"
                @click="selectListingProvider('All')"
              >
                {{ $t('pages.recommendHouse.all_6a72085') }}
              </button>
              <button 
                class="segmented-btn"
                :class="{ active: filters.selectedProvider === 'University' }"
                @click="selectListingProvider('University')"
              >
                {{ $t('pages.recommendHouse.university_715432d') }}
              </button>
              <button 
                class="segmented-btn"
                :class="{ active: filters.selectedProvider === 'Agency' }"
                @click="selectListingProvider('Agency')"
              >
                {{ $t('pages.recommendHouse.agency_5c47e26') }}
              </button>
              <button 
                class="segmented-btn"
                :class="{ active: filters.selectedProvider === 'Private Landlord' }"
                @click="selectListingProvider('Private Landlord')"
              >
                {{ $t('pages.recommendHouse.private_landlord_e5b909a') }}
              </button>
            </div>
            <div class="filter-subsection" v-if="filters.selectedProvider === 'University'">
              <label class="filter-sub-label">
                <div class="icon-card">
                  <i class="fa fa-university icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.university_715432d') }}</span>
              </label>
              <el-select
                v-model="filters.selectedUniversity"
                class="university-filter-select"
                filterable
                clearable
                :placeholder="$t('pages.recommendHouse.select_a_university_80d42c5')"
              >
                <el-option
                  v-for="u in universityOptions"
                  :key="u.id"
                  :label="u.name"
                  :value="u.name"
                />
              </el-select>
              <div class="segmented-control" v-if="filters.selectedUniversity" style="margin-top:10px;">
                <button
                  class="segmented-btn"
                  :class="{ active: filters.selectedUniversityScope === 'all' }"
                  @click="filters.selectedUniversityScope = 'all'"
                >{{ $t('pages.recommendHouse.all_6a72085') }}</button>
                <button
                  class="segmented-btn"
                  :class="{ active: filters.selectedUniversityScope === 'on' }"
                  @click="filters.selectedUniversityScope = 'on'"
                >{{ $t('pages.recommendHouse.on_campus_de78303') }}</button>
                <button
                  class="segmented-btn"
                  :class="{ active: filters.selectedUniversityScope === 'off' }"
                  @click="filters.selectedUniversityScope = 'off'"
                >{{ $t('pages.recommendHouse.off_campus_6fd4374') }}</button>
              </div>
            </div>
          </div>

          <!-- Rooms and beds -->
          <div class="filter-section-enhanced">
            <h4 class="filter-section-title">{{ $t('pages.recommendHouse.rooms_and_beds_1fc6dd7') }}</h4>
            
            <!-- Bedroom Filter -->
            <div class="filter-subsection">
              <label class="filter-sub-label">
                <div class="icon-card">
                  <i class="fa fa-bed icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.bedroom_f69fecd') }}</span>
              </label>
              <div class="pill-group">
                <div 
                  class="filter-pill" 
                  :class="{ active: filters.bedroom === 'any' }"
                  @click="filters.bedroom = 'any'"
                >
                  <span class="pill-radio" :class="{ checked: filters.bedroom === 'any' }"></span>
                  <span>{{ $t('pages.recommendHouse.any_322444d') }}</span>
                </div>
                <div 
                  class="filter-pill" 
                  :class="{ active: filters.bedroom === 'Bunk bed' }"
                  @click="filters.bedroom = 'Bunk bed'"
                >
                  <span class="pill-radio" :class="{ checked: filters.bedroom === 'Bunk bed' }"></span>
                  <span>{{ $t('pages.recommendHouse.bunk_bed_3de27ba') }}</span>
                </div>
                <div 
                  class="filter-pill" 
                  :class="{ active: filters.bedroom === '1 Bed' }"
                  @click="filters.bedroom = '1 Bed'"
                >
                  <span class="pill-radio" :class="{ checked: filters.bedroom === '1 Bed' }"></span>
                  <span>{{ $t('pages.recommendHouse.1_bed_fb8e3a4') }}</span>
                </div>
                <div 
                  class="filter-pill" 
                  :class="{ active: filters.bedroom === '+2 Beds' }"
                  @click="filters.bedroom = '+2 Beds'"
                >
                  <span class="pill-radio" :class="{ checked: filters.bedroom === '+2 Beds' }"></span>
                  <span>{{ $t('pages.recommendHouse.2_beds_435bff3') }}</span>
                </div>
              </div>
            </div>

            <!-- Bathrooms Filter -->
            <div class="filter-subsection">
              <label class="filter-sub-label">
                <div class="icon-card">
                  <i class="fa fa-bath icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.bathrooms_2a0b1c2') }}</span>
              </label>
              <div class="pill-group">
                <div 
                  class="filter-pill" 
                  :class="{ active: filters.bathroom === 'any' }"
                  @click="filters.bathroom = 'any'"
                >
                  <span class="pill-radio" :class="{ checked: filters.bathroom === 'any' }"></span>
                  <span>{{ $t('pages.recommendHouse.any_322444d') }}</span>
                </div>
                <div 
                  class="filter-pill" 
                  :class="{ active: filters.bathroom === '0' }"
                  @click="filters.bathroom = '0'"
                >
                  <span class="pill-radio" :class="{ checked: filters.bathroom === '0' }"></span>
                  <span>{{ $t('pages.recommendHouse.personal_40f0732') }}</span>
                </div>
                <div 
                  class="filter-pill" 
                  :class="{ active: filters.bathroom === '1' }"
                  @click="filters.bathroom = '1'"
                >
                  <span class="pill-radio" :class="{ checked: filters.bathroom === '1' }"></span>
                  <span>{{ $t('pages.recommendHouse.shared_50d0d8d') }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Roommates & Details (Stepper Controls) -->
          <div class="filter-section-enhanced">
            <h4 class="filter-section-title">{{ $t('pages.recommendHouse.details_dc3decb') }}</h4>
            
            <!-- Minimum Roommates Stepper -->
            <div class="stepper-control">
              <label class="stepper-label">
                <div class="icon-card">
                  <i class="fa fa-users icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.min_roommates_bfeb7ec') }}</span>
              </label>
              <div class="stepper-wrapper">
                <button 
                  class="stepper-btn minus"
                  @click.stop="decrementFilter('minRoommates', 0, 10)"
                  :disabled="filters.minRoommates <= 0"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <span class="stepper-value">{{ filters.minRoommates === 0 ? 'Any' : filters.minRoommates }}</span>
                <button 
                  class="stepper-btn plus"
                  @click.stop="incrementFilter('minRoommates', 0, 10)"
                  :disabled="filters.minRoommates >= 10"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>

            <!-- Maximum Roommates Stepper -->
            <div class="stepper-control">
              <label class="stepper-label">
                <div class="icon-card">
                  <i class="fa fa-users icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.max_roommates_27e71b8') }}</span>
              </label>
              <div class="stepper-wrapper">
                <button 
                  class="stepper-btn minus"
                  @click.stop="decrementFilter('maxRoommates', 0, 10)"
                  :disabled="filters.maxRoommates <= 0"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <span class="stepper-value">{{ filters.maxRoommates === 0 ? 'Any' : filters.maxRoommates }}</span>
                <button 
                  class="stepper-btn plus"
                  @click.stop="incrementFilter('maxRoommates', 0, 10)"
                  :disabled="filters.maxRoommates >= 10"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>

            <!-- Minimum Floor Stepper -->
            <div class="stepper-control">
              <label class="stepper-label">
                <div class="icon-card">
                  <i class="fa fa-building icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.min_floor_7336b36') }}</span>
              </label>
              <div class="stepper-wrapper">
                <button 
                  class="stepper-btn minus"
                  @click.stop="decrementFilter('minFloor', 0, 50)"
                  :disabled="filters.minFloor <= 0"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <span class="stepper-value">{{ filters.minFloor === 0 ? 'Any' : filters.minFloor + '/F' }}</span>
                <button 
                  class="stepper-btn plus"
                  @click.stop="incrementFilter('minFloor', 0, 50)"
                  :disabled="filters.minFloor >= 50"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>

            <!-- Rooms Same Address Stepper -->
            <div class="stepper-control">
              <label class="stepper-label">
                <div class="icon-card">
                  <i class="fa fa-home icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.max_floor_5363671') }}</span>
              </label>
              <div class="stepper-wrapper">
                <button 
                  class="stepper-btn minus"
                  @click.stop="decrementFilter('maxFloor', 0, 50)"
                  :disabled="filters.maxFloor <= 0"
                >
                  <i class="fa fa-minus"></i>
                </button>
                <span class="stepper-value">{{ filters.maxFloor === 0 ? 'Any' : filters.maxFloor + '/F' }}</span>
                <button 
                  class="stepper-btn plus"
                  @click.stop="incrementFilter('maxFloor', 0, 50)"
                  :disabled="filters.maxFloor >= 50"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="filter-subsection">
              <label class="filter-sub-label">
                <div class="icon-card">
                  <i class="fa fa-money icon-3d"></i>
                </div>
                <span>{{ $t('pages.recommendHouse.price_range_42363d0') }}</span>
              </label>
              <div class="price-range-grid">
                <input v-model.number="filters.minPrice" type="number" min="0" class="filter-text-input" :placeholder="$t('pages.recommendHouse.min_7eb0cee')" />
                <input v-model.number="filters.maxPrice" type="number" min="0" class="filter-text-input" :placeholder="$t('pages.recommendHouse.max_a95e85a')" />
              </div>
            </div>
          </div>
        </div>
      </aside>

      <!-- RIGHT CONTENT: RESULTS -->
      <main class="content-wrapper" :class="{ 'content-expanded': !showDesktopFilters }">
        
        <!-- Desktop Filter Toggle Button -->
        <button 
          class="desktop-filter-toggle-btn glass-panel" 
          @click="toggleDesktopFilters" 
          v-if="!isMobile"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="4" y1="21" x2="4" y2="14"></line>
            <line x1="4" y1="10" x2="4" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12" y2="3"></line>
            <line x1="20" y1="21" x2="20" y2="16"></line>
            <line x1="20" y1="12" x2="20" y2="3"></line>
            <line x1="1" y1="14" x2="7" y2="14"></line>
            <line x1="9" y1="8" x2="15" y2="8"></line>
            <line x1="17" y1="16" x2="23" y2="16"></line>
          </svg>
          <span>{{ $t('pages.recommendHouse.filters_96e5782') }}</span>
        </button>

        <!-- Mobile Filter Toggle -->
        <button class="mobile-filter-btn glass-panel" @click="toggleFilters" v-if="isMobile">
          <i class="el-icon-s-operation"></i> <span>{{ $t('pages.recommendHouse.filters_map_c2ffed9') }}</span>
        </button>

        <!-- Tabs -->
        <div class="tab-container">
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            :class="['tab-btn', { active: activeTab === index }]"
            @click="setActiveTab(index)"
          >
            {{ tab }}
          </button>
        </div>
        
        <!-- Sort Options -->
        <div class="results-header" v-if="activeTab!=4">
          <div class="results-left">
            <div class="results-title">
              <h2>{{ searchText || 'Default' }} - Latest Results</h2>
              <div class="results-count">
                <span class="count-number">{{ recommendedHouses.length }}</span>
                <span class="count-text">{{ $t('pages.recommendHouse.results_612e12d') }}</span>
              </div>
            </div>
          </div>
          <div class="results-right">
            <div class="sort-options">
              <span class="sort-label">{{ $t('pages.recommendHouse.sort_by_9bb640e') }}</span>
              <button 
                v-for="(option, index) in sortOptions" 
                :key="index"
                :class="['sort-btn', { active: activeSort === index }]"
                @click="setActiveSort(index)"
              >
                {{ option }}
              </button>
            </div>
          </div>
        </div>

        <!-- Map Section (Floats in) - Only for mobile or when NOT on Near tab -->
        <transition name="fade">
          <div class="map-container-premium" v-show="(isMobile || activeTab==14) && recommendedHouses.length > 0 && !isLoading && activeTab != 4">
            <div ref="mapFloating" class="bm-view"></div>
            <div class="map-controls">
               <button @click="centerOnCurrentLocation"><i class="el-icon-aim"></i> {{ $t('pages.recommendHouse.my_location_fba0847') }}</button>
              </div>
              </div>
        </transition>

        <!-- Results Content -->
        <div class="results-content">
          <!-- Loading State -->
          <div v-if="isLoading" class="loading-container glass-panel">
            <div class="spinner-modern"></div>
            <p>{{ $t('pages.recommendHouse.scanning_the_network_for_homes_5c93823') }}</p>
          </div>
          
          <!-- Map Section for Near Tab (when no results) -->
          <div v-else-if="activeTab==4 && recommendedHouses.length === 0" class="map-card">
            <div ref="mapCardEmpty" class="map2"></div>
            <div class="map-text">
              <p>{{ $t('pages.recommendHouse.please_select_the_area_you_are_sea_82558be') }}</p>
            </div>
          </div>

          <!-- Empty State (when not Near tab) -->
          <div v-else-if="!isLoading && recommendedHouses.length === 0 && activeTab != 4" class="empty-state glass-panel">
            <div class="empty-content">
               <div class="empty-icon-wrapper">
                 <i class="el-icon-search"></i>
               </div>
               <h3>{{ $t('pages.recommendHouse.it_is_not_what_you_are_looking_for_6b7739a') }}</h3>
               <p>{{ $t('pages.recommendHouse.wait_for_others_to_share_their_exp_cafd50a') }}</p>
               <button class="primary-btn" @click="goAddHouse">{{ $t('pages.recommendHouse.add_a_review_now_c2a5684') }}</button>
            </div>
          </div>
          
          <!-- House List -->
          <div v-else-if="!isLoading && recommendedHouses.length > 0" class="house-list">
            <!-- Map Section (when there are results) -->
            <div class="map-card" v-if="activeTab==4||activeTab==14">
              <div ref="mapCard" class="map2"></div>
              <div class="map-text">
                <p>{{ $t('pages.recommendHouse.please_select_the_area_you_are_sea_82558be') }}</p>
              </div>
            </div>
            
            <div
              class="house-card"
              v-for="(house, index) in recommendedHouses"
              :key="index"
              @click="goToHouseDetail(house.houseId, house.houseLetId)"
            >
              <div class="house-card-img">
                <img :src="handleImageError(house.initimg)" alt="House Image" @error="useHouseImageFallback($event, house.propertyType)" />
              </div>
              <div class="house-card-content">
                <div class="house-card-header">
                  <span class="house-card-title">{{ house.name }}</span>
                  <span v-if="house.comments > 0" class="house-card-rating" :class="getClass(house.average)">{{ formatSafety(house.average) }}/5.0</span>
                </div>
                <div class="house-card-subtitle">Property Type: {{ house.propertyType || '—' }}</div>
                <div class="house-card-details">
                  <span>{{ $t('pages.recommendHouse.provider_f60f814') }} <b>{{ house.managedByType || house.type }}</b></span>
                  <span v-if="house.comments === 0">{{ $t('emptyState.notReviewedYet') }}</span>
                  <span v-else>{{ $t('pages.recommendHouse.reviews_17f8ebd') }} <b>{{ house.comments }}</b></span>
                  <span>{{ $t('pages.recommendHouse.likes_ea70b16') }} <b>{{ house.stars }}</b></span>
                </div>
                <div class="house-card-price">
                  {{ $t('pages.recommendHouse.avg_price_ec4ddd4') }}
                  <template v-if="house.averagePrice !== null && house.averagePrice !== undefined">
                    HK${{ house.averagePrice }}/mo
                  </template>
                  <template v-else-if="!isAuthenticated">
                    <a class="signin-link" @click.stop="goToSignIn">Sign in to see price</a>
                  </template>
                  <template v-else>—</template>
                </div>
              </div>
              <div class="house-card-actions">
                <el-button class="copy-link-btn" @click.stop="myFunction($event, house)" type="text" size="mini">
                  <i class="el-icon-document-copy"></i> Copy Info
                </el-button>
              </div>
            </div>
          </div>

        </div>

      </main>
        </div>

  </div>
</template>

<style scoped>
/* --- 0. GLOBAL & RESETS --- */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.recommend-all-container {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  min-height: 100vh;
  color: #0f172a;
  position: relative;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.filter-text-input,
.mobile-text-input {
  width: 100%;
  border: 1px solid #dbe4ef;
  border-radius: 12px;
  padding: 10px 12px;
  font: inherit;
  background: #fff;
  color: #0f172a;
}

.university-filter-select {
  width: 100%;
}
.university-filter-select ::v-deep .el-input__inner {
  border: 1px solid #dbe4ef;
  border-radius: 12px;
  min-height: 42px;
  line-height: 1.35;
}
.university-filter-select ::v-deep .el-input.is-focus .el-input__inner {
  border-color: #3bc2ff;
}
.price-range-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

/* --- 1. HEADER --- */
.glass-header {
  position: sticky; top: 0; z-index: 100;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  padding: 16px 24px;
}

.header-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: flex; gap: 20px; align-items: center; justify-content: space-between;
}

.filter-trigger-wrapper { position: relative; }

/* Filter Pill Button */
.filter-pill-btn {
  display: flex; 
  align-items: center; 
  gap: 12px;
  background: white; 
  border: 2px solid #e2e8f0; 
  padding: 12px 24px;
  border-radius: 50px; 
  cursor: pointer; 
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  position: relative; 
  overflow: hidden;
  font-size: 0.95rem;
}
.filter-pill-btn:hover {
  border-color: #3bc2ff; 
  box-shadow: 0 8px 24px rgba(59, 194, 255, 0.15);
  transform: translateY(-1px);
}
.filter-pill-btn.active {
  border-color: #3bc2ff; 
  box-shadow: 0 8px 24px rgba(59, 194, 255, 0.2);
  background: linear-gradient(135deg, rgba(59, 194, 255, 0.05) 0%, rgba(59, 194, 255, 0.02) 100%);
}
.icon-box {
  width: 32px; 
  height: 32px; 
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%); 
  color: #3bc2ff;
  border-radius: 50%; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  font-size: 1.1rem;
}
.btn-text { 
  font-weight: 600; 
  color: #0f172a; 
  max-width: 200px; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
}
.arrow { 
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1); 
  color: #64748b;
  font-size: 1rem;
}
.arrow.rotate { 
  transform: rotate(180deg); 
}

/* Premium Dropdown */
.premium-dropdown {
  position: absolute; 
  top: calc(100% + 16px); 
  left: 0;
  border-radius: 24px; 
  padding: 12px; 
  width: auto; 
  min-width: 240px; 
  max-width: min(920px, calc(100vw - 48px));
  border: 1px solid rgba(59, 194, 255, 0.1); 
  z-index: 200;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: min(720px, calc(100dvh - 100px));
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.dropdown-expand-enter-active, 
.dropdown-expand-leave-active { 
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1); 
}
.dropdown-expand-enter, 
.dropdown-expand-leave-to { 
  opacity: 0; 
  transform: translateY(-12px) scale(0.96); 
}

.col-layout { 
  display: flex; 
  gap: 2px; 
  background: #f8fafc; 
  border-radius: 16px; 
  overflow: hidden; 
  width: fit-content; 
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); 
  flex: 1;
  min-height: 0;
  max-height: min(600px, calc(100dvh - 156px)); 
}
.col { 
  background: white; 
  padding: 20px; 
  overflow-y: auto; 
  min-width: 216px; 
  width: auto; 
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease; 
  flex-shrink: 0; 
}
.col:not(:first-child) {
  animation: slideInFromRight 0.3s ease;
}
@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.col-label { 
  font-size: 0.75rem; 
  text-transform: uppercase; 
  color: #64748b; 
  margin-bottom: 16px; 
  font-weight: 700; 
  letter-spacing: 0.8px; 
}
.list-item {
  padding: 12px 16px; 
  cursor: pointer; 
  border-radius: 10px; 
  display: flex; 
  justify-content: space-between; 
  align-items: center;
  font-size: 0.95rem; 
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); 
  color: #475569;
  margin-bottom: 4px;
}
.list-item:hover { 
  background: #f1f5f9; 
  color: #3bc2ff;
  transform: translateX(4px);
}
.list-item.active { 
  background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%); 
  color: #0284c7; 
  font-weight: 600; 
  box-shadow: 0 2px 8px rgba(59, 194, 255, 0.15);
}
.check-circle { 
  width: 10px; 
  height: 10px; 
  background: #3bc2ff; 
  border-radius: 50%; 
  box-shadow: 0 0 0 3px rgba(59, 194, 255, 0.2);
}

.dropdown-footer { 
  padding: 16px; 
  display: flex; 
  justify-content: flex-end; 
  gap: 12px; 
  border-top: 1px solid #f1f5f9; 
  margin-top: 12px; 
  flex-shrink: 0; 
  background: white; 
  border-radius: 0 0 24px 24px; 
}

.selected-locations-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 16px 8px;
  margin-top: 4px;
}
.location-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #0f172a;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  padding: 6px 10px;
  max-width: 100%;
}
.chip-remove {
  border: none;
  background: transparent;
  cursor: pointer;
  color: #64748b;
  font-size: 1rem;
  line-height: 1;
  padding: 0 2px;
  border-radius: 4px;
}
.chip-remove:hover {
  color: #ef4444;
}
.dropdown-add-location-row {
  padding: 0 16px 8px;
}
.add-location-btn {
  width: 100%;
  padding: 10px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #0284c7;
  background: #f0f9ff;
  border: 1px dashed #7dd3fc;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.add-location-btn:hover {
  background: #e0f2fe;
  border-color: #38bdf8;
}

/* Beam Search Bar */
.search-bar-wrapper { flex: 1; max-width: 600px; }
.search-autocomplete-wrap {
  position: relative;
  z-index: 120;
}
.search-suggestions-panel {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 10px);
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.14);
  max-height: 300px;
  overflow-y: auto;
  padding: 6px;
}
.search-suggestion-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  font: inherit;
  color: #0f172a;
  transition: background 0.15s ease;
}
.search-suggestion-item:hover,
.search-suggestion-item:focus {
  outline: none;
  background: linear-gradient(135deg, #f0f9ff 0%, #eff6ff 100%);
}
.suggestion-title {
  font-weight: 600;
  font-size: 0.95rem;
}
.suggestion-meta {
  font-size: 0.8rem;
  color: #64748b;
}
.search-beam-container {
  position: relative; border-radius: 50px; padding: 2px; overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05); transition: 0.3s;
}
.search-beam-container:hover { box-shadow: 0 10px 25px -5px rgba(59, 194, 255, 0.3); }
.beam-border {
  position: absolute; top: -50%; left: -50%; width: 200%; height: 200%;
  background: conic-gradient(from 0deg, transparent 0deg, #3bc2ff 90deg, transparent 180deg);
  animation: spin 3s linear infinite; opacity: 0; transition: 0.3s;
}
.search-beam-container:hover .beam-border, .search-beam-container:focus-within .beam-border { opacity: 1; }

.search-input-group {
  position: relative; background: white; border-radius: 50px; display: flex; align-items: center;
  padding: 6px 6px 6px 20px;
}
.search-icon { color: #94a3b8; margin-right: 12px; font-size: 1.2rem; }
.search-input-group input { flex: 1; border: none; outline: none; font-size: 1rem; color: #0f172a; }
.search-submit-btn {
  background: #0f172a; color: white; border: none; padding: 10px 24px; border-radius: 50px;
  font-weight: 600; cursor: pointer; transition: 0.3s;
}
.search-submit-btn:hover { background: #3bc2ff; transform: scale(1.05); }

/* --- 2. LAYOUT GRID --- */
.main-grid {
  display: grid; 
  grid-template-columns: clamp(460px, 32vw, 560px) minmax(0, 1fr); 
  gap: 32px;
  max-width: 1600px;
  margin: 0 auto; 
  padding: 24px 24px 56px; 
  align-items: start; 
  position: relative; 
  z-index: 1;
  width: 100%; 
  box-sizing: border-box;
  transition: grid-template-columns 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.main-grid.filters-hidden {
  grid-template-columns: 1fr;
}

/* Glass Panel Sidebar */
.glass-panel {
  border-radius: 24px;
}

.sidebar { 
  position: sticky; 
  top: 88px; 
  align-self: start;
  padding: 0; 
  max-height: calc(100dvh - 96px); 
  display: flex; 
  flex-direction: column; 
  overflow: hidden;
  min-height: 0;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
  transform: translateX(0);
  opacity: 1;
  pointer-events: auto;
  z-index: 10;
  width: 100%;
}

.sidebar.sidebar-hidden {
  transform: translateX(-100%);
  opacity: 0;
  pointer-events: none;
  position: absolute;
  width: clamp(460px, 32vw, 560px);
  z-index: -1;
}

.sidebar-header-desktop {
  display: none;
}

.sidebar-header-desktop h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.filter-scroll-area { 
  overflow-y: auto; 
  overflow-x: visible;
  padding: 0; 
  flex: 1;
  min-height: 0;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

.filter-scroll-area::-webkit-scrollbar {
  width: 4px;
}

.filter-scroll-area::-webkit-scrollbar-track {
  background: transparent;
}

.filter-scroll-area::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

.filter-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #cbd5e1;
}

/* Filter Cards - Individual bordered sections */
.filter-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.filter-card:last-child {
  margin-bottom: 0;
}

.filter-card-label {
  display: block;
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 20px;
}

/* Pill Group - Max 2 items per row */
.pill-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  width: 100%;
  overflow: visible;
}

.filter-pill {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 18px;
  background: #ffffff;
  border: 1.5px solid #d1d5db;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  pointer-events: auto;
  position: relative;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
}

.filter-pill:hover {
  background: #f8fafc;
  border-color: #94a3b8;
}

.filter-pill.active {
  background: #e0f2fe;
  border-color: #3bc2ff;
  color: #0f172a;
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(59, 194, 255, 0.1);
}

/* Radio circle inside pill */
.pill-radio {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 50%;
  border: 2px solid #9ca3af;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
  box-sizing: border-box;
  flex-shrink: 0;
}

.pill-radio::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: transparent;
  transition: all 0.2s ease;
  display: block;
}

.filter-pill.active .pill-radio,
.pill-radio.checked {
  border-color: #3bc2ff;
  border-width: 6px;
  background: #ffffff;
}

.filter-pill.active .pill-radio::after,
.pill-radio.checked::after {
  content: '' !important;
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  background: #3bc2ff !important;
  display: block !important;
}

.filter-pill.active .pill-radio,
.pill-radio.checked {
  border-color: #3bc2ff !important;
  border-width: 6px !important;
  background: #ffffff !important;
}

.filter-pill:active {
  transform: scale(0.98);
}

/* Slider Rows */
.slider-row {
  margin-bottom: 20px;
}

.slider-row:last-child {
  margin-bottom: 0;
}

.slider-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.slider-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
}

.slider-value {
  font-size: 0.9rem;
  font-weight: 600;
  color: #3bc2ff;
  min-width: 40px;
  text-align: right;
}

.modern-slider {
  width: 100%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 4px;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}

.modern-slider::-webkit-slider-thumb {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  background: #3bc2ff;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transition: all 0.15s ease;
}

.modern-slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(59, 194, 255, 0.3);
}

.modern-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: #3bc2ff;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.modern-slider::-moz-range-track {
  height: 4px;
  background: #e5e7eb;
  border-radius: 4px;
}

/* Sidebar Footer */
.sidebar-footer { 
  padding: 16px 0 0;
  border-top: none;
  display: flex; 
  gap: 10px;
  background: transparent;
}

/* Enhanced Filter Design (Airbnb-inspired) */
.sidebar-header-desktop-enhanced {
  padding: 24px 24px 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  flex-shrink: 0;
}

.filter-title-main {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.filter-section-enhanced {
  padding: 24px;
  margin-bottom: 0;
  border-bottom: 1px solid #e2e8f0;
  overflow: visible;
  width: 100%;
  box-sizing: border-box;
}

.filter-section-enhanced:first-of-type {
  padding-top: 24px;
}

.filter-section-enhanced:last-of-type {
  border-bottom: none;
  padding-bottom: 24px;
}

.filter-section-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 16px 0;
  letter-spacing: -0.01em;
}

.filter-subsection {
  margin-bottom: 20px;
}

.filter-subsection:last-child {
  margin-bottom: 0;
}

.filter-sub-label {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 12px;
}

.filter-sub-label span {
  flex: 1;
}

/* Beautiful Icon Cards (3D Neumorphic Style) */
.icon-card {
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  background: #ffffff;
  border: 1.5px solid #e5e7eb;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 6px 12px rgba(0, 0, 0, 0.08),
    0 3px 6px rgba(0, 0, 0, 0.1),
    inset 0 2px 3px rgba(255, 255, 255, 0.98),
    inset 0 -1px 2px rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.icon-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.6) 100%);
  border-radius: 16px;
  pointer-events: none;
}

.icon-card .icon-3d {
  font-size: 32px;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  display: inline-block;
  font-weight: normal;
  line-height: 1;
}

/* Specific icon colors and 3D effects */
.icon-card .fa-bed {
  color: #0284c7;
  text-shadow: 
    0 3px 6px rgba(139, 92, 246, 0.4),
    0 2px 4px rgba(139, 92, 246, 0.3),
    0 1px 2px rgba(139, 92, 246, 0.2);
  filter: drop-shadow(0 3px 5px rgba(139, 92, 246, 0.35));
}

.icon-card .fa-bath {
  color: #06b6d4;
  text-shadow: 
    0 3px 6px rgba(6, 182, 212, 0.4),
    0 2px 4px rgba(6, 182, 212, 0.3),
    0 1px 2px rgba(6, 182, 212, 0.2);
  filter: drop-shadow(0 3px 5px rgba(6, 182, 212, 0.35));
}

.icon-card .fa-users {
  color: #f59e0b;
  text-shadow: 
    0 3px 6px rgba(245, 158, 11, 0.4),
    0 2px 4px rgba(245, 158, 11, 0.3),
    0 1px 2px rgba(245, 158, 11, 0.2);
  filter: drop-shadow(0 3px 5px rgba(245, 158, 11, 0.35));
}

.icon-card .fa-building {
  color: #10b981;
  text-shadow: 
    0 3px 6px rgba(16, 185, 129, 0.4),
    0 2px 4px rgba(16, 185, 129, 0.3),
    0 1px 2px rgba(16, 185, 129, 0.2);
  filter: drop-shadow(0 3px 5px rgba(16, 185, 129, 0.35));
}

.icon-card .fa-home {
  color: #ef4444;
  text-shadow: 
    0 3px 6px rgba(239, 68, 68, 0.4),
    0 2px 4px rgba(239, 68, 68, 0.3),
    0 1px 2px rgba(239, 68, 68, 0.2);
  filter: drop-shadow(0 3px 5px rgba(239, 68, 68, 0.35));
}

.icon-card .fa-money {
  color: #059669;
  text-shadow:
    0 3px 6px rgba(5, 150, 105, 0.35),
    0 2px 4px rgba(5, 150, 105, 0.25),
    0 1px 2px rgba(5, 150, 105, 0.2);
  filter: drop-shadow(0 3px 5px rgba(5, 150, 105, 0.35));
}

.icon-card:hover {
  transform: translateY(-3px);
  box-shadow: 
    0 6px 12px rgba(0, 0, 0, 0.1),
    0 3px 6px rgba(0, 0, 0, 0.08),
    inset 0 1px 2px rgba(255, 255, 255, 1),
    inset 0 -1px 1px rgba(0, 0, 0, 0.03);
  border-color: #d1d5db;
}

.icon-card:hover .icon-3d {
  transform: scale(1.2) translateY(-2px);
}

.icon-card:hover .fa-bed {
  filter: drop-shadow(0 4px 8px rgba(139, 92, 246, 0.5));
}

.icon-card:hover .fa-bath {
  filter: drop-shadow(0 4px 8px rgba(6, 182, 212, 0.5));
}

.icon-card:hover .fa-users {
  filter: drop-shadow(0 4px 8px rgba(245, 158, 11, 0.5));
}

.icon-card:hover .fa-building {
  filter: drop-shadow(0 4px 8px rgba(16, 185, 129, 0.5));
}

.icon-card:hover .fa-home {
  filter: drop-shadow(0 4px 8px rgba(239, 68, 68, 0.5));
}

.icon-card:hover .fa-money {
  filter: drop-shadow(0 4px 8px rgba(5, 150, 105, 0.45));
}

/* Segmented Control (Type of place) */
.segmented-control {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
  background: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
  overflow: visible;
  width: 100%;
  box-sizing: border-box;
}

.segmented-btn {
  padding: 10px 12px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
  white-space: normal;
  text-align: center;
  line-height: 1.25;
  min-width: 0;
  position: relative;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

.segmented-btn:hover {
  background: rgba(59, 194, 255, 0.1);
  color: #3bc2ff;
}

.segmented-btn.active {
  background: linear-gradient(135deg, #3bc2ff 0%, #0284c7 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(59, 194, 255, 0.3);
}

/* Stepper Controls */
.stepper-control {
  margin-bottom: 20px;
}

.stepper-control:last-child {
  margin-bottom: 0;
}

.stepper-label {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 12px;
}

.stepper-label span {
  flex: 1;
}

.stepper-label .icon-card {
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  background: #ffffff;
  border: 1.5px solid #e5e7eb;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 6px 12px rgba(0, 0, 0, 0.08),
    0 3px 6px rgba(0, 0, 0, 0.1),
    inset 0 2px 3px rgba(255, 255, 255, 0.98),
    inset 0 -1px 2px rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.stepper-label .icon-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.6) 100%);
  border-radius: 16px;
  pointer-events: none;
}

.stepper-label .icon-card .icon-3d {
  font-size: 32px;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  display: inline-block;
  font-weight: normal;
  line-height: 1;
}

.stepper-label .icon-card .fa-users {
  color: #f59e0b;
  text-shadow: 
    0 3px 6px rgba(245, 158, 11, 0.4),
    0 2px 4px rgba(245, 158, 11, 0.3),
    0 1px 2px rgba(245, 158, 11, 0.2);
  filter: drop-shadow(0 3px 5px rgba(245, 158, 11, 0.35));
}

.stepper-label .icon-card .fa-building {
  color: #10b981;
  text-shadow: 
    0 3px 6px rgba(16, 185, 129, 0.4),
    0 2px 4px rgba(16, 185, 129, 0.3),
    0 1px 2px rgba(16, 185, 129, 0.2);
  filter: drop-shadow(0 3px 5px rgba(16, 185, 129, 0.35));
}

.stepper-label .icon-card .fa-home {
  color: #ef4444;
  text-shadow: 
    0 3px 6px rgba(239, 68, 68, 0.4),
    0 2px 4px rgba(239, 68, 68, 0.3),
    0 1px 2px rgba(239, 68, 68, 0.2);
  filter: drop-shadow(0 3px 5px rgba(239, 68, 68, 0.35));
}

.stepper-label .icon-card:hover {
  transform: translateY(-3px);
  box-shadow: 
    0 6px 12px rgba(0, 0, 0, 0.1),
    0 3px 6px rgba(0, 0, 0, 0.08),
    inset 0 1px 2px rgba(255, 255, 255, 1),
    inset 0 -1px 1px rgba(0, 0, 0, 0.03);
  border-color: #d1d5db;
}

.stepper-label .icon-card:hover .icon-3d {
  transform: scale(1.2) translateY(-2px);
}

.stepper-label .icon-card:hover .fa-users {
  filter: drop-shadow(0 4px 8px rgba(245, 158, 11, 0.5));
}

.stepper-label .icon-card:hover .fa-building {
  filter: drop-shadow(0 4px 8px rgba(16, 185, 129, 0.5));
}

.stepper-label .icon-card:hover .fa-home {
  filter: drop-shadow(0 4px 8px rgba(239, 68, 68, 0.5));
}

.stepper-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.2s ease;
  width: 100%;
}

.stepper-wrapper:hover {
  border-color: #cbd5e1;
}

.stepper-btn {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #475569;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  flex-shrink: 0;
}

.stepper-btn i {
  font-size: 16px;
  line-height: 1;
}

.stepper-btn.minus i {
  font-size: 18px;
  font-weight: bold;
  color: #ef4444;
}

.stepper-btn.plus i {
  font-size: 18px;
  font-weight: bold;
  color: #10b981;
}

.stepper-btn:hover:not(:disabled) {
  border-color: #3bc2ff;
  background: #f0f9ff;
  transform: scale(1.05);
}

.stepper-btn.minus:hover:not(:disabled) {
  border-color: #ef4444;
  background: #fef2f2;
}

.stepper-btn.minus:hover:not(:disabled) i {
  color: #dc2626;
}

.stepper-btn.plus:hover:not(:disabled) {
  border-color: #10b981;
  background: #f0fdf4;
}

.stepper-btn.plus:hover:not(:disabled) i {
  color: #059669;
}

.stepper-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.stepper-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: #e2e8f0;
  background: #f8fafc;
}

.stepper-value {
  flex: 1;
  text-align: center;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0f172a;
  min-width: 60px;
}

/* Filter actions (placed under title, above scroll — keeps buttons visible on PC) */
.sidebar-footer-enhanced {
  padding: 16px 24px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}

.filter-action-btn {
  flex: 1;
  padding: 14px 24px;
  border-radius: 12px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  white-space: nowrap;
}

.clear-btn {
  background: #ffffff;
  color: #475569;
  border: 1.5px solid #e2e8f0;
}

.clear-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
}

.apply-btn {
  background: #3bc2ff;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(59, 194, 255, 0.25);
}

.apply-btn:hover {
  background: #0284c7;
  box-shadow: 0 4px 12px rgba(59, 194, 255, 0.35);
  transform: translateY(-1px);
}

.apply-btn:active {
  transform: translateY(0);
}

.sidebar-header-mobile { display: none; }
.dropdown-header-mobile { display: none; }
.primary-btn { background: #3bc2ff; color: white; border: none; padding: 12px; border-radius: 12px; font-weight: 600; cursor: pointer; flex: 1; transition: 0.3s; }
.primary-btn:hover { background: #0284c7; transform: translateY(-2px); }
.outline-btn { background: transparent; border: 1px solid #e2e8f0; color: #64748b; padding: 12px; border-radius: 12px; cursor: pointer; flex: 1; transition: 0.3s; }
.outline-btn:hover { border-color: #94a3b8; color: #0f172a; }

.primary-btn.sm { padding: 10px 24px; font-size: 0.9rem; font-weight: 700; border-radius: 10px; min-width: 120px; box-shadow: 0 4px 12px rgba(59, 194, 255, 0.3); }
.text-btn { background: transparent; border: 2px solid #e2e8f0; color: #64748b; cursor: pointer; font-size: 0.9rem; font-weight: 600; padding: 10px 20px; border-radius: 10px; transition: 0.3s; min-width: 80px; }
.text-btn:hover { border-color: #3bc2ff; color: #3bc2ff; background: rgba(59, 194, 255, 0.05); transform: translateY(-1px); }

/* --- 3. RESULTS AREA --- */
.content-wrapper { 
  flex: 1; 
  position: relative;
  transition: margin-left 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* Desktop Filter Toggle Button */
.desktop-filter-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  margin-bottom: 20px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  color: #374151;
  border: 1.5px solid #d1d5db;
  background: white;
  border-radius: 50px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  width: fit-content;
}

.desktop-filter-toggle-btn:hover {
  border-color: #3bc2ff;
  color: #3bc2ff;
  box-shadow: 0 4px 12px rgba(59, 194, 255, 0.15);
  transform: translateY(-1px);
}

.desktop-filter-toggle-btn:active {
  transform: translateY(0);
}

.desktop-filter-toggle-btn svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Original Tab Container - Full Width */
.tab-container {
  display: flex;
  justify-content: flex-start;
  gap: 6px;
  margin: 0 0 24px 0;
  background: transparent;
  border-radius: 0;
  padding: 0;
  width: 100%;
  box-shadow: none;
}
.tab-btn {
  background: #ffffff;
  border: 2px solid #e2e8f0;
  padding: 14px 28px;
  cursor: pointer;
  font-size: 0.95rem;
  color: #64748b;
  border-radius: 50px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  box-shadow: 
    0 2px 4px rgba(0, 0, 0, 0.04),
    0 1px 2px rgba(0, 0, 0, 0.06);
}
.tab-btn:hover {
  background-color: #f8fafc;
  color: #475569;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 
    0 4px 8px rgba(0, 0, 0, 0.06),
    0 2px 4px rgba(0, 0, 0, 0.08);
}
.tab-btn.active {
  background: linear-gradient(135deg, #3bc2ff 0%, #0284c7 100%);
  color: #ffffff;
  border-color: #3bc2ff;
  box-shadow: 
    0 6px 16px rgba(59, 194, 255, 0.35),
    0 3px 8px rgba(59, 194, 255, 0.25);
  font-weight: 700;
  transform: translateY(-2px);
}

/* Results Header & Sort */
.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px 0;
}
.results-left {
  flex: 1;
}
.results-title {
  display: flex;
  align-items: center;
  gap: 16px;
}
.results-title h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.results-count {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.count-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #3bc2ff;
}
.count-text {
  font-size: 0.9rem;
  color: #64748b;
}
.results-right {
  display: flex;
  align-items: center;
}
.sort-options {
  display: flex;
  align-items: center;
  gap: 12px;
}
.sort-label {
  font-size: 0.95rem;
  color: #64748b;
  font-weight: 500;
}
.sort-btn {
  background: white;
  border: 2px solid #e2e8f0;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  color: #64748b;
  transition: all 0.2s;
  font-weight: 500;
}
.sort-btn:hover {
  border-color: #3bc2ff;
  color: #3bc2ff;
}
.sort-btn.active {
  background: #3bc2ff;
  border-color: #3bc2ff;
  color: white;
}

/* Map */
.map-container-premium {
  height: 250px; 
  border-radius: 20px; 
  overflow: hidden; 
  margin-bottom: 32px; 
  margin-top: 24px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1); 
  border: 4px solid white;
}
.map-controls { position: absolute; bottom: 15px; left: 15px; z-index: 10; }
.map-controls button {
  background: white; border: none; padding: 8px 12px; border-radius: 8px; font-weight: 600;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1); cursor: pointer; display: flex; align-items: center; gap: 6px;
}

/* GRID & CARDS */
.grid-inner { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 24px; }
.list-stagger-enter-active { transition: all 0.5s ease; transition-delay: var(--delay); }
.list-stagger-enter { opacity: 0; transform: translateY(20px); }

/* Results Content */
.results-content {
  width: 100%;
  margin-top: 24px;
}
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top-color: #3bc2ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.house-list {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.house-card {
  display: flex;
  align-items: flex-start;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 16px rgba(74,144,226,0.10);
  padding: 24px;
  transition: box-shadow 0.2s, transform 0.2s;
  cursor: pointer;
  gap: 24px;
  position: relative;
}
.house-card:hover {
  box-shadow: 0 8px 32px rgba(74,144,226,0.16);
  transform: translateY(-4px) scale(1.01);
}
.house-card-img {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
  background: #eaf4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.house-card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.house-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.house-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.house-card-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #357ab8;
}
.house-card-rating {
  font-weight: bold;
  font-size: 1.1rem;
  padding: 4px 12px;
  border-radius: 10px;
  background-color: #E8E121;
  color: #fff;
}
.house-card-rating.number1 {
  background-color: #25D366;
}
.house-card-rating.rating-low {
  background-color: #E74C3C;
}
.house-card-subtitle {
  font-size: 1rem;
  color: #7b8ca6;
}
.house-card-price {
  font-size: 0.98rem;
  color: #5a6c7d;
  margin-top: 4px;
}
.house-card-price .signin-link {
  color: #4a90e2;
  cursor: pointer;
  text-decoration: underline;
}
.house-card-details {
  display: flex;
  gap: 18px;
  font-size: 0.98rem;
  color: #5a6c7d;
  margin-top: 4px;
}
.house-card-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  min-width: 100px;
  gap: 8px;
}
.copy-link-btn {
  color: #357ab8 !important;
  font-weight: 500 !important;
  background: #eaf4ff !important;
  border-radius: 8px !important;
  padding: 4px 12px !important;
  transition: background 0.2s, color 0.2s;
}
.copy-link-btn:hover {
  background: #4a90e2 !important;
  color: #fff !important;
}
.map-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(74,144,226,0.10);
  padding: 32px 24px 24px 24px;
  margin: 0 auto 24px auto;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.map2 {
  width: 100%;
  max-width: 500px;
  height: 300px;
  margin: 0 auto 16px auto;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(60, 120, 200, 0.10);
}
.map-text {
  text-align: center;
  color: #357ab8;
  font-size: 1.08rem;
  margin-top: 8px;
}
.no-results {
  margin-top: 16px;
  text-align: center;
}
.no-results-box {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(74,144,226,0.10);
  padding: 48px 24px;
  max-width: 600px;
  margin: 0 auto;
}
.no-results-box .p1 {
  color: #7b8ca6;
  font-size: 1.08rem;
  margin: 12px 0;
}
.no-results-box .p2 {
  color: #357ab8;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 12px;
}
.add-review-btn {
  background: linear-gradient(90deg, #4a90e2 60%, #6eb1f7 100%) !important;
  color: #fff !important;
  font-weight: 700 !important;
  font-size: 1.1rem !important;
  border-radius: 10px !important;
  padding: 12px 32px !important;
  border: none !important;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(74,144,226,0.10);
  transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
  margin-top: 16px;
}
.add-review-btn:hover {
  background: linear-gradient(90deg, #357ab8 60%, #4a90e2 100%) !important;
  box-shadow: 0 4px 16px rgba(74,144,226,0.14);
  transform: translateY(-2px) scale(1.04);
}

/* Empty & Loading */
.loading-container, .empty-state { 
  text-align: center; 
  padding: 60px; 
  border-radius: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  margin-top: 16px;
  margin-bottom: 32px;
  clear: both;
}
.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.empty-content h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.empty-content p {
  font-size: 0.95rem;
  color: #64748b;
  margin: 0;
  max-width: 100%;
  width: 100%;
  text-align: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.empty-content .primary-btn {
  margin-top: 8px;
  padding: 12px 24px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 12px;
}
.spinner-modern {
  width: 40px; height: 40px; border: 3px solid #e2e8f0; border-top-color: #3bc2ff;
  border-radius: 50%; margin: 0 auto 20px; animation: spin 0.8s linear infinite;
}
.empty-icon-wrapper { 
  font-size: 3rem; 
  color: #cbd5e1; 
  margin-bottom: 20px; 
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes spin { 100% { transform: rotate(360deg); } }

/* Filter Backdrop Overlay */
.filter-backdrop,
.dropdown-backdrop {
  display: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* --- 4. MOBILE --- */
@media (max-width: 768px) {
  .recommend-all-container {
    padding-top: 10px;
  }
  
  .glass-header {
    padding: 12px 16px;
  }
  
  .header-inner {
    flex-direction: column;
    gap: 12px;
  }
  
  .filter-trigger-wrapper {
    width: 100%;
  }

  .filter-pill-btn {
    width: 100%;
    justify-content: space-between;
    padding: 12px 16px;
  }
  
  .filter-pill-btn .btn-text {
    max-width: none;
    flex: 1;
    text-align: left;
  }
  
  .search-bar-wrapper {
    width: 100%;
    max-width: none;
  }
  
  .search-input-group {
    padding: 4px 4px 4px 16px;
  }
  
  .search-input-group input {
    font-size: 0.9rem;
  }
  
  .search-submit-btn {
    display: none;
  }
  
  .header-inner { flex-direction: column; align-items: stretch; }
  .filter-pill-btn { justify-content: space-between; width: 100%; }
  .search-bar-wrapper { max-width: 100%; }

  .write-review-btn {
    width: 100%;
    justify-content: center;
    margin-top: 12px;
  }
  .main-grid { grid-template-columns: 1fr; padding: 24px 16px 48px; margin: 0 auto; }
  
  /* Hide desktop sidebar completely on mobile - use mobile-filter-overlay instead */
  .sidebar {
    display: none !important;
  }
  
  /* Hide desktop filter toggle on mobile */
  .desktop-filter-toggle-btn {
    display: none !important;
  }
  
  .sidebar-header-desktop {
    display: none !important;
  }
  
  /* Filter header with close button */
  .sidebar-header-mobile { 
    display: flex !important; 
    justify-content: space-between; 
    align-items: center; 
    padding: 16px 20px;
    font-weight: 700; 
    font-size: 1.1rem;
    border-bottom: 1px solid #e2e8f0;
    background: #ffffff;
    flex-shrink: 0;
  }
  
  .sidebar-header-mobile h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #0f172a;
  }
  
  /* Close button styling */
  .close-filters-btn,
  .sidebar-header-mobile button { 
    background: #f1f5f9; 
    border: none; 
    color: #334155;
    cursor: pointer;
    padding: 0;
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    transition: all 0.2s ease;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
  
  .close-filters-btn:hover,
  .close-filters-btn:active,
  .sidebar-header-mobile button:hover,
  .sidebar-header-mobile button:active {
    background: #e2e8f0;
    color: #0f172a;
  }
  
  /* Scrollable filter content */
  .filter-scroll-area {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 16px 20px;
    padding-bottom: 100px; /* Space for footer */
    -webkit-overflow-scrolling: touch;
  }
  
  /* Fixed footer with buttons */
  .sidebar-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 20px;
    background: white;
    border-top: 1px solid #e2e8f0;
    display: flex;
    gap: 12px;
    z-index: 10;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
  }
  
  .mobile-filter-btn {
    display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%;
    padding: 14px; margin-bottom: 20px; font-weight: 700; cursor: pointer; color: #3bc2ff;
    border: 2px solid #e2e8f0;
    background: white;
    -webkit-tap-highlight-color: transparent;
  }
  
  .tab-container { flex-wrap: wrap; gap: 6px; padding: 8px 12px; }
  .tab-btn { padding: 8px 16px; font-size: 14px; }
  .results-header { 
    flex-direction: column; 
    gap: 16px; 
    align-items: flex-start; 
    padding: 14px 0;
  }
  .results-title {
    flex-wrap: wrap;
    gap: 12px;
  }
  .results-title h2 {
    font-size: 1.35rem;
  }
  .results-right {
    width: 100%;
  }
  .sort-options { 
    flex-wrap: wrap; 
    gap: 10px;
    width: 100%;
  }
  .sort-label {
    font-size: 0.9rem;
  }
  .sort-btn {
    font-size: 0.875rem;
    padding: 8px 16px;
  }
  
  /* Mobile Dropdown - Full Screen Filter Location */
  .premium-dropdown { 
    position: fixed; 
    top: 0; 
    left: 0; 
    width: 100vw; 
    height: 100vh; 
    max-height: 100vh;
    border-radius: 0; 
    display: flex; 
    flex-direction: column; 
    padding: 0; 
    max-width: 100vw;
    z-index: 500;
    background: white;
    overflow: hidden;
  }
  .dropdown-expand-enter, .dropdown-expand-leave-to { 
    opacity: 0; 
    transform: translateY(-20px) scale(0.98);
  }
  .dropdown-header-mobile { 
    padding: 20px 20px; 
    border-bottom: 1px solid #e2e8f0; 
    display: flex; 
    justify-content: space-between; 
    align-items: center;
    font-weight: 700;
    background: white;
    flex-shrink: 0;
  }
  .dropdown-header-mobile h3 {
    margin: 0;
    font-size: 1.1rem;
    color: #0f172a;
  }
  .dropdown-header-mobile button { 
    background: #f1f5f9; 
    border: none; 
    font-size: 1.5rem; 
    color: #64748b;
    cursor: pointer;
    padding: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    -webkit-tap-highlight-color: transparent;
    line-height: 1;
  }
  .dropdown-header-mobile button:active {
    background: #e2e8f0;
  }
  
  /* District/Location columns stacked vertically */
  .col-layout { 
    flex-direction: column; 
    height: auto; 
    flex: 1; 
    border-radius: 0; 
    background: #f8fafc; 
    width: 100%; 
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .col { 
    width: 100%; 
    border-bottom: 1px solid #e2e8f0; 
    padding: 16px 20px; 
    max-height: none;
    background: white;
    margin-bottom: 8px;
  }
  .col:last-child {
    margin-bottom: 0;
  }
  .col-label {
    font-size: 0.85rem;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .list-item {
    padding: 14px 16px;
    margin-bottom: 6px;
    border-radius: 10px;
    font-size: 0.95rem;
    background: #f8fafc;
    -webkit-tap-highlight-color: transparent;
  }
  .list-item:last-child {
    margin-bottom: 0;
  }
  .list-item.active {
    background: #e0f2fe;
    color: #0284c7;
  }
  .list-item:active {
    background: #e2e8f0;
  }
  
  .dropdown-footer {
    padding: 16px 20px;
    border-top: 1px solid #e2e8f0;
    background: white;
    flex-shrink: 0;
    display: flex;
    gap: 12px;
  }
  .dropdown-footer .text-btn,
  .dropdown-footer .primary-btn.sm {
    flex: 1;
    padding: 14px 20px;
    font-size: 0.95rem;
    border-radius: 12px;
    min-height: 48px;
  }
  
  .action-btn { opacity: 1; transform: none; background: rgba(255,255,255,0.95); }
  
  /* Filter backdrop visible on mobile */
  .filter-backdrop {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 299;
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
  }
  
  .dropdown-backdrop {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 499;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
  }
  
  .sidebar-header-mobile {
    display: flex !important;
  }
  
  .dropdown-header-mobile {
    display: flex !important;
  }
}

/* --- 5. MOBILE PHONES (480px) --- */
@media (max-width: 480px) {
  .recommend-all-container {
    padding-top: 0;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }
  
  .glass-header {
    padding: 10px 12px;
    position: sticky;
    top: 0;
    z-index: 100;
  }
  
  .header-inner {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  
  .filter-pill-btn {
    width: 100%;
    padding: 10px 14px;
    font-size: 0.9rem;
  }
  
  .filter-pill-btn .icon-box {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
  
  .filter-pill-btn .btn-text {
    font-size: 0.85rem;
  }
  
  .search-bar-wrapper {
    width: 100%;
  }
  
  .search-input-group {
    padding: 4px 16px 4px 12px;
  }
  
  .search-input-group input {
    font-size: 0.85rem;
    padding: 10px 0;
  }
  
  .search-submit-btn {
    display: none;
  }
  
  .main-grid {
    grid-template-columns: 1fr;
    padding: 0 12px;
    margin-top: 16px;
    gap: 0;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  
  .mobile-filter-btn {
    width: 100%;
    padding: 14px;
    margin-bottom: 16px;
    font-size: 0.95rem;
    border-radius: 14px;
    font-weight: 600;
    -webkit-tap-highlight-color: transparent;
  }
  
  .mobile-filter-btn:active {
    background: #f8fafc;
    transform: scale(0.98);
  }
  
  .tab-container {
    flex-wrap: wrap;
    gap: 6px;
    padding: 8px 12px;
  }
  
  .tab-btn {
    padding: 8px 16px;
    font-size: 14px;
  }
  
  .results-header {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
    padding: 12px 0;
  }
  
  .results-left {
    width: 100%;
  }
  
  .results-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }
  
  .results-title h2 {
    font-size: 1.25rem;
    line-height: 1.3;
    width: 100%;
  }
  
  .results-count {
    align-self: flex-start;
  }
  
  .count-number {
    font-size: 1.25rem;
  }
  
  .count-text {
    font-size: 0.85rem;
  }
  
  .results-right {
    width: 100%;
  }
  
  .sort-options {
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    align-items: flex-start;
  }
  
  .sort-label {
    font-size: 0.875rem;
    width: 100%;
    margin-bottom: 4px;
  }
  
  .sort-btn {
    font-size: 0.875rem;
    padding: 8px 16px;
    border-radius: 8px;
    flex: 1;
    min-width: 0;
  }
  
  .house-card {
    flex-direction: column;
    gap: 16px;
  }
  
  .house-card-img {
    width: 100%;
    height: 200px;
  }
  
  .map-card {
    margin: 16px 0;
    padding: 16px;
  }
  
  .map2 {
    height: 250px;
  }
  
  .card-image-box {
    height: 180px;
  }
  
  .card-badge {
    top: 8px;
    left: 8px;
    padding: 4px 10px;
    font-size: 0.75rem;
  }
  
  .card-actions {
    top: 8px;
    right: 8px;
    gap: 6px;
  }
  
  .action-btn {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
    opacity: 1;
    transform: none;
  }
  
  .card-details {
    padding: 14px;
  }
  
  .card-title {
    font-size: 1rem;
    max-width: 65%;
  }
  
  .rating-badge {
    font-size: 0.75rem;
    padding: 4px 8px;
  }

  .rate-text {
    display: none; /* Hide "Rate Now" text on mobile for space */
  }
  
  .card-sub {
    font-size: 0.85rem;
    margin-bottom: 10px;
  }
  
  .card-meta {
    padding-top: 10px;
    gap: 12px;
    font-size: 0.8rem;
  }
  
  /* Hide desktop sidebar on smaller phones too */
  .sidebar {
    display: none !important;
  }
  
  /* Location dropdown - full screen mobile */
  .premium-dropdown {
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  
  .dropdown-header-mobile {
    padding: 16px 20px;
    flex-shrink: 0;
    background: white;
    border-bottom: 1px solid #e2e8f0;
  }
  
  .dropdown-header-mobile h3 {
    font-size: 1.1rem;
    font-weight: 700;
  }
  
  .dropdown-header-mobile button {
    width: 36px;
    height: 36px;
    font-size: 1.4rem;
  }
  
  .col-layout {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background: #f8fafc;
    padding-bottom: 80px;
  }
  
  .col {
    padding: 16px 20px;
    max-height: none;
    background: white;
    margin: 8px;
    border-radius: 12px;
    border: none;
  }
  
  .col:first-child {
    margin-top: 8px;
  }
  
  .col-label {
    font-size: 0.8rem;
    margin-bottom: 12px;
    color: #64748b;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .list-item {
    padding: 14px 16px;
    font-size: 0.95rem;
    border-radius: 10px;
    margin-bottom: 8px;
    background: #f8fafc;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
  
  .list-item:last-child {
    margin-bottom: 0;
  }
  
  .list-item:active {
    background: #e2e8f0;
  }
  
  .list-item.active {
    background: #e0f2fe;
    color: #0284c7;
    font-weight: 600;
  }
  
  .dropdown-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 20px;
    background: white;
    border-top: 1px solid #e2e8f0;
    gap: 12px;
    z-index: 10;
    display: flex;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
  }
  
  .text-btn,
  .primary-btn.sm {
    flex: 1;
    padding: 14px 20px;
    font-size: 0.95rem;
    min-height: 48px;
    border-radius: 12px;
    font-weight: 600;
    -webkit-tap-highlight-color: transparent;
  }
  
  .text-btn:active,
  .primary-btn.sm:active {
    transform: scale(0.98);
    opacity: 0.9;
  }
  
  /* Fix search results box and empty state */
  .loading-container,
  .empty-state {
    padding: 32px 16px;
    border-radius: 16px;
    margin-top: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin-left: 0;
    margin-right: 0;
    overflow: hidden;
  }
  
  .content-wrapper {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    padding-bottom: 20px;
  }
  
  .empty-content {
    gap: 12px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  
  .empty-content h3 {
    font-size: 1.1rem;
    text-align: center;
    padding: 0 12px;
    word-wrap: break-word;
  }
  
  .empty-content p {
    font-size: 0.85rem;
    padding: 0 12px;
    max-width: 100%;
    width: 100%;
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  .empty-content .primary-btn {
    padding: 12px 24px;
    font-size: 0.9rem;
    width: auto;
    min-width: 140px;
    -webkit-tap-highlight-color: transparent;
  }
  
  .spinner-modern {
    width: 32px;
    height: 32px;
    border-width: 2px;
  }
  
  .empty-icon-wrapper {
    font-size: 2.5rem;
    margin-bottom: 12px;
  }
  
  /* Make X button in filter section more visible and larger on mobile phones */
  .mobile-filter-header {
    padding: 20px 16px;
  }
  
  .mobile-close-btn {
    width: 56px;
    height: 56px;
    min-width: 56px;
    min-height: 56px;
    background: #e2e8f0;
    border: 2px solid #cbd5e1;
    border-radius: 16px;
    color: #0f172a;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .mobile-close-btn svg {
    width: 28px;
    height: 28px;
    stroke-width: 3;
  }
  
  .mobile-close-btn:active {
    background: #cbd5e1;
    border-color: #94a3b8;
    transform: scale(0.96);
  }
}

/* ========================================
   MOBILE FULLSCREEN FILTER OVERLAY
   ======================================== */
.mobile-filter-overlay {
  position: fixed;
  top: 72px; /* Below the navbar */
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: calc(100vh - 72px);
  height: calc(100dvh - 72px);
  background: #ffffff;
  z-index: 500; /* Above page content but below app navigation modals */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
}

/* Hide mobile overlay on desktop (above 768px) */
@media (min-width: 769px) {
  .mobile-filter-overlay {
    display: none !important;
  }
}

.mobile-filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  flex-shrink: 0;
}

.mobile-filter-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
}

.mobile-close-btn {
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  background: #f1f5f9;
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #334155;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.mobile-close-btn:active {
  background: #e2e8f0;
  transform: scale(0.95);
}

.mobile-close-btn svg {
  width: 24px;
  height: 24px;
}

.mobile-filter-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
  padding-bottom: 100px;
  -webkit-overflow-scrolling: touch;
}

.mobile-filter-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: none;
}

.mobile-filter-label {
  display: block;
  font-size: 1.05rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 16px;
  letter-spacing: -0.02em;
}

.mobile-radio-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.mobile-radio-item {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 12px 20px;
  background: #ffffff;
  border: 2px solid #d1d5db;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
  white-space: nowrap;
}

.mobile-radio-item:active {
  transform: scale(0.98);
}

.mobile-radio-item.active {
  background: #e0f2fe;
  border-color: #3bc2ff;
  color: #0c4a6e;
}

.mobile-radio-dot {
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 50%;
  border: 2px solid #9ca3af;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
}

.mobile-radio-dot::after {
  content: '';
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: transparent;
  transition: all 0.2s ease;
}

.mobile-radio-dot.checked {
  border-color: #3bc2ff;
  border-width: 6px;
}

.mobile-radio-dot.checked::after {
  background: transparent;
}

.mobile-slider-value {
  font-size: 1rem;
  font-weight: 700;
  color: #3bc2ff;
  margin-bottom: 12px;
}

.mobile-slider {
  width: 100%;
  height: 3px;
  background: #e2e8f0;
  border-radius: 10px;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
}

.mobile-slider::-webkit-slider-thumb {
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  background: #3bc2ff;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.15);
}

.mobile-slider::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: #3bc2ff;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.15);
}

.mobile-filter-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 12px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
}

.mobile-clear-btn {
  flex: 1;
  padding: 14px;
  background: #ffffff;
  border: 2px solid #d1d5db;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.mobile-clear-btn:active {
  background: #f9fafb;
  transform: scale(0.98);
}

.mobile-apply-btn {
  flex: 2;
  padding: 14px;
  background: #3bc2ff;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.mobile-apply-btn:active {
  background: #0ea5e9;
  transform: scale(0.98);
}

/* --- DESKTOP FILTER STYLES (769px+) --- */
@media (min-width: 769px) {
  /* --- LAYOUT GRID --- */
  .main-grid {
    display: grid;
    grid-template-columns: clamp(460px, 32vw, 560px) minmax(0, 1fr);
    gap: 40px;
    max-width: 1400px;
    margin: 40px auto;
    padding: 0 24px;
    align-items: start;
    position: relative;
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
    transition: grid-template-columns 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .main-grid.filters-hidden {
    grid-template-columns: 1fr;
  }

  /* Glass Panel Sidebar */
  .glass-panel {
    border-radius: 24px;
  }

  .sidebar {
    position: sticky;
    top: 88px;
    align-self: start;
    padding: 0;
    max-height: calc(100dvh - 96px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
    transform: translateX(0);
    opacity: 1;
  }

  .sidebar.sidebar-hidden {
    transform: translateX(-100%);
    opacity: 0;
    pointer-events: none;
    position: absolute;
    width: clamp(460px, 32vw, 560px);
    left: 0;
    z-index: -1;
  }

  .sidebar:not(.sidebar-hidden) {
    pointer-events: auto;
    z-index: 10;
  }

  .filter-scroll-area {
    overflow-y: auto;
    overflow-x: visible;
    padding-right: 8px;
    flex: 1;
    min-height: 0;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    box-sizing: border-box;
  }

  .filter-scroll-area::-webkit-scrollbar {
    width: 6px;
  }

  .filter-scroll-area::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }

  .filter-scroll-area::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }

  .filter-scroll-area::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }

  /* Individual Filter Cards */
  .filter-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 20px;
    padding: 24px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    flex-shrink: 0;
  }

  .filter-card:last-of-type {
    margin-bottom: 0;
  }

  .filter-group {
    display: flex;
    flex-direction: column;
  }

  .filter-group .filter-label {
    display: block;
    font-weight: 700;
    margin-bottom: 12px;
    color: #0f172a;
    font-size: 0.95rem;
  }

  .filter-group label {
    display: block;
    font-weight: 700;
    margin-bottom: 12px;
    color: #0f172a;
    font-size: 0.95rem;
  }

  /* Pill Group - Max 2 items per row */
  .pill-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    width: 100%;
    overflow: visible;
  }

  /* Filter Pill - Modern pill-shaped buttons */
  .filter-pill {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 18px;
    background: #ffffff;
    border: 1.5px solid #d1d5db;
    border-radius: 50px;
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    pointer-events: auto;
    position: relative;
    z-index: 1;
    width: 100%;
    box-sizing: border-box;
  }

  .filter-pill:hover {
    background: #f8fafc;
    border-color: #94a3b8;
    transform: translateY(-1px);
  }

  .filter-pill.active {
    background: #e0f2fe;
    border-color: #3bc2ff;
    color: #0f172a;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(59, 194, 255, 0.1);
  }

  /* Radio circle inside pill */
  .pill-radio {
    width: 20px;
    height: 20px;
    min-width: 20px;
    border-radius: 50%;
    border: 2px solid #9ca3af;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    position: relative;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .pill-radio::after {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: transparent;
    transition: all 0.2s ease;
  }

  .filter-pill.active .pill-radio,
  .pill-radio.checked {
    border-color: #3bc2ff !important;
    border-width: 6px !important;
    background: #ffffff !important;
  }

  .filter-pill.active .pill-radio::after,
  .pill-radio.checked::after {
    content: '' !important;
    width: 8px !important;
    height: 8px !important;
    border-radius: 50% !important;
    background: #3bc2ff !important;
    display: block !important;
  }

  .filter-pill span:not(.pill-radio) {
    flex: 1;
  }

  /* Range Slider Styling */
  .range-val {
    color: #3bc2ff;
    font-weight: 700;
    font-size: 0.95rem;
    margin-bottom: 12px;
    margin-top: 4px;
  }

  .styled-range {
    width: 100% !important;
    height: 2px !important;
    background: #e2e8f0 !important;
    border-radius: 10px;
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    outline: none !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .styled-range::-webkit-slider-thumb {
    appearance: none !important;
    -webkit-appearance: none !important;
    width: 12px !important;
    height: 12px !important;
    background: #3bc2ff !important;
    border-radius: 50% !important;
    cursor: pointer;
    border: 2px solid white !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
    transition: 0.2s;
    margin-top: -5px !important;
  }

  .styled-range::-moz-range-thumb {
    width: 12px !important;
    height: 12px !important;
    background: #3bc2ff !important;
    border-radius: 50% !important;
    cursor: pointer;
    border: 2px solid white !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
  }

  .styled-range::-moz-range-track {
    height: 2px !important;
    background: #e2e8f0 !important;
    border-radius: 10px !important;
  }

  .styled-range::-webkit-slider-thumb:hover {
    transform: scale(1.1);
  }

  /* Sidebar Footer Buttons */
  .sidebar-footer {
    margin-top: 20px;
    display: flex;
    gap: 10px;
  }

  .primary-btn {
    background: #3bc2ff;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    flex: 1;
    transition: 0.3s;
  }

  .primary-btn:hover {
    background: #0284c7;
    transform: translateY(-2px);
  }

  .outline-btn {
    background: transparent;
    border: 1px solid #e2e8f0;
    color: #64748b;
    padding: 12px;
    border-radius: 12px;
    cursor: pointer;
    flex: 1;
    transition: 0.3s;
  }

  .outline-btn:hover {
    border-color: #94a3b8;
    color: #0f172a;
  }
}

</style>

<script>
import axios from 'axios';
import { useHouseImageFallback } from '@/utils/houseImageFallback';
import Swal from 'sweetalert2';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

  export default {
  components: {},
  computed:{
  isAuthenticated() {
      return !!localStorage.getItem('token');
    },
  availableDistricts() {
      return this.selectedRegion ? this.districts[this.selectedRegion] || [] : [];
    },
    availableAreas() {
      return this.selectedDistrict ? this.areas[this.selectedDistrict] || [] : [];
    },
    locationFilterSummary() {
      const picks = this.collectLocationPicksForSearch();
      if (!picks.length) {
        return 'Filter Location';
      }
      if (picks.length === 1) {
        return this.locationPickLabel(picks[0]);
      }
      return picks.length + ' locations';
    }
},
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.fetchUniversityOptions();
    const keyword = this.$route.query.keyword;
    this.getCurrentPosition();
    this.$nextTick(() => this._initLeafletMap('mapFloating', 14, '#3bc2ff', '#3bc2ff', 0.1));

    if (keyword) {
      this.searchText = keyword;
      this.search(keyword);
    } else {
      this.searchText = "";
      this.search("");
    }

    document.addEventListener('click', this.handleClickOutside);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    document.removeEventListener('click', this.handleClickOutside);
    if (this.searchAutocompleteTimer) clearTimeout(this.searchAutocompleteTimer);
    ['mapFloating', 'mapCardEmpty', 'mapCard'].forEach(key => {
      if (this['_lmap_' + key]) { this['_lmap_' + key].remove(); this['_lmap_' + key] = null; }
      this['_lhouseMarkers_' + key] = null;
    });
  },

  watch: {
    activeTab(val) {
      this.$nextTick(() => {
        if (val === 4) {
          if (this.$refs.mapCardEmpty && !this['_lmap_mapCardEmpty']) {
            this._initLeafletMap('mapCardEmpty', 12, '#e74c3c', '#e74c3c', 0);
          } else if (this['_lmap_mapCardEmpty']) {
            this['_lmap_mapCardEmpty'].invalidateSize();
          }
        }
        if (val === 4 || val === 14) {
          if (this.$refs.mapCard && !this['_lmap_mapCard']) {
            this._initLeafletMap('mapCard', 12, '#e74c3c', '#e74c3c', 0);
          } else if (this['_lmap_mapCard']) {
            this['_lmap_mapCard'].invalidateSize();
          }
        }
        if (this['_lmap_mapFloating']) this['_lmap_mapFloating'].invalidateSize();
      });
    },
    isLoading(val) {
      if (!val) {
        this.$nextTick(() => {
          if (this['_lmap_mapFloating']) this['_lmap_mapFloating'].invalidateSize();
          if (this.activeTab === 4 && this.$refs.mapCardEmpty && !this['_lmap_mapCardEmpty']) {
            this._initLeafletMap('mapCardEmpty', 12, '#e74c3c', '#e74c3c', 0);
          }
          if ((this.activeTab === 4 || this.activeTab === 14) && this.$refs.mapCard && !this['_lmap_mapCard']) {
            this._initLeafletMap('mapCard', 12, '#e74c3c', '#e74c3c', 0);
          }
        });
      }
    },
    recommendedHouses() {
      this.$nextTick(() => this._syncHouseMarkersAllMaps && this._syncHouseMarkersAllMaps());
    }
  },

        data() {
        return {
                universityOptions: [],
                showFilters: false,
                regions: [
        "Hong Kong Island",
        "Kowloon",
        "New Territories"
      ],
      districts: {
        "Hong Kong Island": [
          "Central and Western",
          "Eastern",
          "Southern",
          "Wan Chai"
        ],
        "Kowloon": [
          "Yau Tsim Mong",
          "Sham Shui Po",
          "Kowloon City",
          "Kwun Tong",
          "Wong Tai Sin"
        ],
        "New Territories": [
          "Sha Tin",
          "Sai Kung",
          "Tai Po",
          "North",
          "Tsuen Wan",
          "Kwai Tsing",
          "Tuen Mun",
          "Yuen Long",
          "Islands"
        ]
      },
      areas: {
        "Central and Western": [
          "Sheung Wan",
          "Mid-Levels",
          "Sai Ying Pun",
          "Admiralty",
          "Peak",
          "Central",
          "Shek Tong Tsui",
          "Kennedy Town"
        ],
        "Eastern": [
          "Quarry Bay",
          "Sai Wan Ho",
          "Siu Sai Wan",
          "Aldrich Bay",
          "Tin Hau",
          "North Point",
          "Shau Kei Wan",
          "Chai Wan"
        ],
        "Southern": [
          "Aberdeen",
          "Ap Lei Chau",
          "Chung Hom Kok",
          "Repulse Bay",
          "Shek O",
          "Tai Tam",
          "Wong Chuk Hang",
          "Stanley",
          "Pok Fu Lam"
        ],
        "Wan Chai": [
          "Causeway Bay",
          "Happy Valley",
          "Wan Chai",
          "Tai Hang",
          "Jardine's Lookout"
        ],
        "Yau Tsim Mong": [
          "Tsim Sha Tsui",
          "King's Park",
          "West Kowloon Reclamation",
          "Tai Kok Tsui",
          "Mong Kok",
          "Yau Ma Tei",
          "Jordan"
        ],
        "Sham Shui Po": [
          "Cheung Sha Wan",
          "Yau Yat Tsuen",
          "Shek Kip Mei",
          "Mei Foo",
          "Sham Shui Po",
          "Lai Chi Kok"
        ],
        "Kowloon City": [
          "To Kwa Wan",
          "Ma Tau Kok",
          "Kai Tak",
          "Ma Tau Wai",
          "Beacon Hill",
          "Hung Hom",
          "Kowloon City",
          "Kowloon Tong",
          "Ho Man Tin"
        ],
        "Kwun Tong": [
          "Ngau Tau Kok",
          "Kowloon Bay",
          "Yau Tong",
          "Jordan Valley",
          "Kwun Tong",
          "Lam Tin"
        ],
        "Wong Tai Sin": [
          "Diamond Hill",
          "Tsz Wan Shan",
          "Ngau Chi Wan",
          "San Po Kong",
          "Wong Tai Sin",
          "Choi Hung"
        ],
        "Sha Tin": [
          "Fo Tan",
          "Ma On Shan",
          "Ma Liu Shui",
          "Sha Tin Wai",
          "Siu Lek Yuen",
          "Wu Kai Sha",
          "Sha Tin",
          "Tai Wai"
        ],
        "Sai Kung": [
          "Clear Water Bay",
          "Hang Hau",
          "Sai Kung",
          "Tiu Keng Leng",
          "Po Lam",
          "Tseung Kwan O"
        ],
        "Tai Po": [
          "Tai Po Market",
          "Tai Po",
          "Tai Wo"
        ],
        "North": [
          "Fanling",
          "Luen Wo Hui",
          "Sheung Shui",
          "Sha Tau Kok"
        ],
        "Tsuen Wan": [
          "Tsuen Wan",
          "Ma Wan",
          "Sham Tseng",
          "Lei Muk Shue"
        ],
        "Kwai Tsing": [
          "Kwai Fong",
          "Tsing Yi",
          "Kwai Chung"
        ],
        "Tuen Mun": [
          "Tuen Mun",
          "Lam Tei"
        ],
        "Yuen Long": [
          "Tin Shui Wai",
          "Ha Tsuen",
          "San Tin",
          "Hung Shui Kiu",
          "Yuen Long",
          "Kam Tin"
        ],
        "Islands": [
          "Tung Chung",
          "Mui Wo",
          "Cheung Chau",
          "Peng Chau"
        ]
      },
          mapCenter: { lat: 0.0, lng: 0.0 },
          markerPosition: null,
          circlePath: {
            center: {
              lng: 116.404,
              lat: 39.915
            },
            radius: 5000
          },
          isStarred: 0,
          defaultImageSrc: "/avatar/1.png",
          name: "QuadrantLayout",
          searchText: '',
          autocompleteSuggestions: [],
          searchAutocompleteTimer: null,
          searchSuggestionsOpen: false,
          recommendedHouses: [],
          tabs: ['Popular', 'New', 'Likes','High Score','Near'],
          sortOptions: ['Default', 'Reverse'],
          activeTab: 0,
          activeSort: 0,
          starredHouses: {},
          isLoading: false,
          isMobile: false,
          searchError: null,
          showDesktopFilters: true,
                filters: {
                  selectedProvider:'All',
                  selectedUniversity:'',
                  selectedUniversityScope:'all',
            type: 'any',
            bedroom: 'any',
            // {
            //   any: false,
            //   bunk: false,
            //   one: false,
            //   twoPlus: false
            // },
            bathroom: 'any',
            // {
            //   any: false,
            //   personal: false,
            //   shared: false
            // },
            minRoommates: 0,
            maxRoommates: 0,
            minFloor: 0,
            maxFloor: 0,
            minPrice: 0,
            maxPrice: 0
          },
          // Advanced Filter Properties
          isFilterDropdownOpen: false,
          activeFilterTab: 0,
          filterTabs: ['District'],
          
          // District Tab Selections
          selectedRegion: '',
          selectedDistrict: '',
          selectedArea: 'ALL AREAS',
          selectedAreas: [],
          /** Committed multi-location picks (OR); draft in selectedRegion/selectedDistrict/selectedAreas merged on search */
          selectedLocations: [],
          
          // MTR Tab Selections
          selectedMTRLine: '',
          selectedMTRStation: '',
          selectedMTRDistance: 'ALL DISTANCES',
          
          // University Tab Selections
          selectedUniversity: '',
          selectedUniversityDistance: '',
          selectedUniversityTransport: 'ALL TRANSPORT',
          
          // Leasing Company Tab Selections
          selectedCompany: '',
          selectedCompanyType: '',
          selectedCompanyRating: 'ALL RATINGS',

    };
  },

  methods: {
    useHouseImageFallback,
    goToSignIn() {
      this.$router.push({ path: '/LogReg', query: { redirect: this.$route.fullPath } });
    },
    fetchUniversityOptions() {
      axios
        .get('/api/info/university', { timeout: 15000 })
        .then((response) => {
          const rows = response.data && response.data.data;
          this.universityOptions = Array.isArray(rows) ? rows : [];
        })
        .catch(() => {
          this.universityOptions = [];
        });
    },
    selectListingProvider(value) {
      this.filters.selectedProvider = value;
      if (value !== 'University') {
        this.filters.selectedUniversity = '';
        this.filters.selectedUniversityScope = 'all';
      }
    },
    handleSearchInput() {
      if (this.searchAutocompleteTimer) clearTimeout(this.searchAutocompleteTimer);
      const q = (this.searchText || '').trim();
      if (!q) {
        this.autocompleteSuggestions = [];
        this.searchSuggestionsOpen = false;
        return;
      }
      this.searchSuggestionsOpen = true;
      this.searchAutocompleteTimer = setTimeout(() => {
        this.fetchAutocompleteSuggestions(this.searchText);
      }, 280);
    },
    onSearchFocus() {
      const q = (this.searchText || '').trim();
      if (!q) return;
      if (this.autocompleteSuggestions.length) {
        this.searchSuggestionsOpen = true;
      } else {
        this.handleSearchInput();
      }
    },
    selectAutocompleteSuggestion(item) {
      const primary = item.name || item.detailedArea || item.street || '';
      this.searchText = primary || this.formatAutocompleteLabel(item);
      this.autocompleteSuggestions = [];
      this.searchSuggestionsOpen = false;
      this.searchit();
    },
    focusFirstSuggestion() {
      const el = this.$el.querySelector('.search-suggestion-item');
      if (el) el.focus();
    },
    fetchAutocompleteSuggestions(keyword) {
      const normalizedKeyword = (keyword || '').trim();
      if (!normalizedKeyword) {
        this.autocompleteSuggestions = [];
        this.searchSuggestionsOpen = false;
        return;
      }

      axios.get('/api/search/autocomplete', {
        params: {
          keyword: normalizedKeyword,
          limit: 8
        }
      })
      .then((response) => {
        this.autocompleteSuggestions = response.data.data || [];
        this.searchSuggestionsOpen =
          ((this.searchText || '').trim().length > 0) && this.autocompleteSuggestions.length > 0;
      })
      .catch(() => {
        this.autocompleteSuggestions = [];
        this.searchSuggestionsOpen = false;
      });
    },
    formatAutocompleteLabel(item) {
      return [item.name, item.area, item.district].filter(Boolean).join(' • ');
    },
    normalizeOptionalRange(value) {
      return Number(value) > 0 ? Number(value) : null;
    },
    providerLegacyCode(provider) {
      if (provider === 'University') return 1;
      if (provider === 'Agency' || provider === 'Private Landlord') return 2;
      return 0;
    },
    isAreaSelected(area) {
      return this.selectedAreas.includes(area);
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleButtonHover(e) {
      const btn = e.currentTarget;
      btn.style.transform = 'scale(1.05)';
    },
    handleButtonLeave(e) {
      e.currentTarget.style.transform = '';
    },
    centerOnCurrentLocation() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const center = { lat: latitude, lng: longitude };
          this.mapCenter = center;
          this.circlePath.center = center;
          this._syncLeafletMaps();
          this.searchit();
        },
        (error) => {
          console.error('Unable to retrieve current location:', error);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    
    toggleDesktopFilters() {
      this.showDesktopFilters = !this.showDesktopFilters;
    },
    
    testBackendConnection() {
      console.log("=== TESTING BACKEND CONNECTION ===");
      
      // Test basic connectivity with better error handling
      axios.get('/api/test', { timeout: 10000 })
        .then(response => {
          console.log("✅ Backend is accessible:", response.data);
        })
        .catch(error => {
          console.error("❌ Backend connection failed:", error.message);
          
          // Try the search endpoint as fallback
          axios.get('/api/search/searchElliotFilter', { 
            params: { keyword: "", lat: 22.302711, lon: 114.177216, status: 0 },
            timeout: 10000 
          })
          .then(() => {
            console.log("✅ Search endpoint is accessible");
          })
          .catch(searchError => {
            console.error("❌ Search endpoint also failed:", searchError.message);
            this.searchError = "Backend connection failed. Please check if the server is running.";
          });
        });
    },
    
    handleMapClick(e) {
      const { lat, lng } = e.latlng;
      this.mapCenter = { lng, lat };
      this.circlePath.center = this.mapCenter;
      this._syncLeafletMaps();
      this.searchit();
    },

    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            this.mapCenter = { lng: longitude, lat: latitude };
            this.markerPosition = { lng: longitude, lat: latitude };
            this.circlePath.center = this.mapCenter;
            this._syncLeafletMaps();
          },
          (error) => {
            console.error('获取位置失败：', error);
            this.mapCenter = { lng: 114.177216, lat: 22.302711 };
            this.markerPosition = { lng: 114.177216, lat: 22.302711 };
            this.circlePath.center = this.mapCenter;
            this._syncLeafletMaps();
          }
        );
      } else {
        console.error('浏览器不支持 Geolocation');
      }
    },
    
    formatSafety(value) {
      return parseFloat(value).toFixed(1);
    },
    
    myFunction(event, house) {
      event.stopPropagation();
      const rating = house.average != null ? parseFloat(house.average).toFixed(1) : 'N/A';
      const ratingLine = house.comments > 0
        ? `⭐ Rating: ${rating}/5.0`
        : `⭐ ${this.$t('emptyState.notReviewedYet')}`;
      const info = [
        `🏠 ${house.name || 'Unknown Property'}`,
        `📍 ${[house.street, house.area, house.district, house.region].filter(Boolean).join(', ') || 'Location not available'}`,
        `🏢 Unit: ${house.houseletname || 'N/A'}`,
        ratingLine,
        `💬 Reviews: ${house.comments || 0}`,
        `❤️ Likes: ${house.stars || 0}`,
        `🏷️ Provider: ${house.managedByType || house.type || 'N/A'}`,
        `🔗 Type: ${house.propertyType || 'N/A'}`
      ].join('\n');

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(info).then(() => {
          Swal.fire({ icon: 'success', title: 'Copied!', text: 'House info copied to clipboard', timer: 1500, showConfirmButton: false });
        }).catch(() => this._fallbackCopy(info));
      } else {
        this._fallbackCopy(info);
      }
    },
    _fallbackCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      Swal.fire({ icon: 'success', title: 'Copied!', text: 'House info copied to clipboard', timer: 1500, showConfirmButton: false });
    },

    _initLeafletMap(refKey, zoom, strokeColor, fillColor, fillOpacity) {
      const el = this.$refs[refKey];
      if (!el || this['_lmap_' + refKey]) return;
      const center = [this.mapCenter.lat || 22.302711, this.mapCenter.lng || 114.177216];
      const map = L.map(el, { zoomControl: true, attributionControl: false }).setView(center, zoom);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(map);
      const marker = L.marker(center).addTo(map);
      const circle = L.circle(center, {
        radius: (this.circlePath.radius || 1) * 1000,
        color: strokeColor, fillColor, fillOpacity
      }).addTo(map);
      map.on('click', this.handleMapClick);
      this['_lmap_' + refKey] = map;
      this['_lmarker_' + refKey] = marker;
      this['_lcircle_' + refKey] = circle;
      this['_lhouseMarkers_' + refKey] = L.layerGroup().addTo(map);
      this._renderHouseMarkers(refKey);
    },

    _renderHouseMarkers(refKey) {
      const map = this['_lmap_' + refKey];
      const layer = this['_lhouseMarkers_' + refKey];
      if (!map || !layer) return;
      layer.clearLayers();
      const points = [];
      (this.recommendedHouses || []).forEach((h) => {
        const lat = parseFloat(h.lat);
        const lon = parseFloat(h.lon);
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
        const m = L.marker([lat, lon]);
        const title = h.houseletname || h.houseLetName || h.name || 'Listing';
        const subtitle = [h.area, h.district].filter(Boolean).join(' · ');
        m.bindPopup(`<strong>${title}</strong>${subtitle ? '<br>' + subtitle : ''}`);
        layer.addLayer(m);
        points.push([lat, lon]);
      });
      if (points.length > 0) {
        try {
          map.fitBounds(L.latLngBounds(points), { padding: [24, 24], maxZoom: 16 });
        } catch (e) { /* single-point or fitBounds failure: ignore */ }
      }
    },

    _syncHouseMarkersAllMaps() {
      ['mapFloating', 'mapCardEmpty', 'mapCard'].forEach(k => this._renderHouseMarkers(k));
    },

    _syncLeafletMaps() {
      const lat = this.mapCenter.lat || 22.302711;
      const lng = this.mapCenter.lng || 114.177216;
      const latlng = [lat, lng];
      const radiusM = (this.circlePath.radius || 1) * 1000;
      ['mapFloating', 'mapCardEmpty', 'mapCard'].forEach(key => {
        const map = this['_lmap_' + key];
        if (!map) return;
        map.setView(latlng);
        const marker = this['_lmarker_' + key];
        if (marker) marker.setLatLng(latlng);
        const circle = this['_lcircle_' + key];
        if (circle) { circle.setLatLng(latlng); circle.setRadius(radiusM); }
      });
    },
    
    toggleStar1(houseidid) {
      this.isStarred = !this.isStarred;
      axios.get('/api/house/starHouse', {
        params: {
          houseId: houseidid,
        },
        timeout: 10000
      })
      .then((response) => {
        console.log("Star toggled successfully:", response.data);
      })
      .catch((error) => {
        console.error("Failed to toggle star:", error);
        // Revert the state if the request failed
        this.isStarred = !this.isStarred;
      });
    },
    
    toggleStar(event, houseletid) {
      const originalState = this.starredHouses[houseletid];
      this.starredHouses[houseletid] = !this.starredHouses[houseletid];
      event.stopPropagation();
      
      axios.get('/api/house/starHouse', {
        params: {
          houseId: houseletid,
        },
        timeout: 10000
      })
      .then((response) => {
        console.log("Star toggled successfully:", response.data);
      })
      .catch((error) => {
        console.error("Failed to toggle star:", error);
        // Revert the state if the request failed
        this.starredHouses[houseletid] = originalState;
      });
    },
    
    getClass(value) {
      const v = parseFloat(value);
      if (!Number.isFinite(v)) return 'number';
      if (v >= 4) return 'number1';
      if (v < 3) return 'rating-low';
      return 'number';
    },
    
    handleImageError(imageSrc) {
      if (!imageSrc || imageSrc === 'null') return this.defaultImageSrc;
      let url = String(imageSrc).trim();
      // Strip query string (e.g. presigned URL params)
      const q = url.indexOf('?');
      if (q !== -1) url = url.slice(0, q);
      // Extract /reviewimages/... from full or partial URLs
      // (handles http://127.0.0.1:9005/reviewimages/... and /reviewimages/... alike)
      const ri = url.indexOf('/reviewimages/');
      if (ri !== -1) return url.slice(ri);
      // Already a clean absolute path (e.g. /avatar/1.png)
      if (url.startsWith('/')) return url;
      // Bare filename with no path prefix — assume it lives in MinIO reviewimages bucket
      return '/reviewimages/' + url;
    },

    getSentence(obj, houseletid) {
      axios.get('/api/house/searchStarHouse', {
        params: {
          houseId: houseletid,
        },
        timeout: 10000
      })
      .then((response) => {
        console.log("Star status retrieved for house:", houseletid);
        obj.starredHouses[houseletid] = response.data.data;
      })
      .catch((error) => {
        console.error("Failed to get star status:", error);
        obj.starredHouses[houseletid] = false;
      });
    },
    
    setActiveTab(index) {
      this.activeTab = index;
      this.searchit();
    },

    setActiveSort(index) {
      this.activeSort = index;
      this.searchit();
    },
    
    goAddHouse() {
      this.$router.push('/AddHouse');
    },
    
    clearFilters() {
      // Reset all filters to default values
      this.filters = {
            selectedProvider: 'All',
            selectedUniversity: '',
            selectedUniversityScope: 'all',
            type: 'any',
            bedroom: 'any',
            bathroom: 'any',
            minRoommates: 0,
            maxRoommates: 0,
            minFloor: 0,
            maxFloor: 0,
            minPrice: 0,
            maxPrice: 0
      };
      
      // Reset search text
      this.searchText = '';
      this.selectedRegion = '';
      this.selectedDistrict = '';
      this.selectedArea = 'ALL AREAS';
      this.selectedAreas = [];
      this.selectedLocations = [];
      
      // Trigger new search with cleared filters
      this.searchit();
    },
    
    // Stepper control methods
    incrementFilter(filterName, min, max) {
      const current = Number(this.filters[filterName] || 0);
      if (current < max) {
        this.filters[filterName] = current + 1;
      }
    },
    
    decrementFilter(filterName, min, max) { // eslint-disable-line no-unused-vars
      const current = Number(this.filters[filterName] || 0);
      if (current > min) {
        this.filters[filterName] = current - 1;
      } else {
        this.filters[filterName] = min;
      }
    },
    
    goToHouseDetail(houseId, houseletId) {
      this.$router.push({ path: '/HouseReviewScore', query: { houseId: houseId, houseLetId: houseletId } });
    },
    consoleLogFilter(){
      console.log(this.filters)
    },
    search(event) {
      console.log("filter")
      console.log(this.filter)
      // Handle different types of search calls
      if (event && event.target && event.target.value !== undefined) {
        // This is a keyboard event from the input field
        this.searchText = event.target.value;
      } else if (typeof event === 'string') {
        // This is a direct keyword call
        this.searchText = event;
      } else if (event && event.key === 'Enter') {
        // This is an Enter key event
        this.searchText = event.target.value;
      } else {
        // Fallback to current searchText
        this.searchText = this.searchText || "";
      }
      
      console.log("Searching for:", this.searchText);
      this.searchit();
    },
    
    searchit() {
      this.ToHouseReviewScore(this);
    },
    
    ToHouseReviewScore(obj) {
      var status = obj.activeTab + obj.activeSort * 10;
      console.log("=== SEARCH DEBUG ===");
      console.log("Status:", status);
      console.log("Search Text:", this.searchText);
      console.log("Map Center:", this.mapCenter);
      console.log("Active Tab:", this.activeTab);
      console.log("Active Sort:", this.activeSort);

      // Set loading state
      obj.isLoading = true;
      obj.searchError = null;

      // Check if we have valid coordinates
      if (!this.mapCenter.lat || !this.mapCenter.lng) {
        console.error("No valid coordinates available!");
        this.mapCenter = { lat: 22.302711, lng: 114.177216 }; // Default to Hong Kong
      }

      const searchParams = {
        keyword: this.searchText,
        lat: this.mapCenter.lat,
        lon: this.mapCenter.lng,
        status: status,
        selectedRegion: this.selectedRegion,
        selectedDistrict: this.selectedDistrict,
        selectedArea: this.selectedArea,
        selectedAreas: this.selectedAreas,
        selectedLocations: this.serializeLocationPicksForApi(),
        selectedProvider: this.filters.selectedProvider,
        selectedUniversity: this.filters.selectedUniversity,
        selectedUniversityScope: this.filters.selectedUniversity ? (this.filters.selectedUniversityScope || 'all') : null,
        selectedULtype: this.providerLegacyCode(this.filters.selectedProvider),

            selectedType: this.filters.type,
            selectedBedroom: this.filters.bedroom,
            selectedBathrooms: this.filters.bathroom,
            selectedRoommates: this.filters.maxRoommates > 0 ? String(this.filters.maxRoommates) : 'any',
            selectedFloorRoommates: 'any',
            selectedFloor: 'any',
            minRoommates: this.normalizeOptionalRange(this.filters.minRoommates),
            maxRoommates: this.normalizeOptionalRange(this.filters.maxRoommates),
            minFloor: this.normalizeOptionalRange(this.filters.minFloor),
            maxFloor: this.normalizeOptionalRange(this.filters.maxFloor),
            minPrice: this.normalizeOptionalRange(this.filters.minPrice),
            maxPrice: this.normalizeOptionalRange(this.filters.maxPrice)
      };

      console.log("API Request Parameters:", searchParams);
      console.log("API Endpoint: /api/search/searchElliotFilter");

      axios.post('/api/search/searchElliotFilter', searchParams,{
        timeout: 10000 // 10 second timeout
      })
      .then(function (response) {
        console.log("=== API RESPONSE ===");
        console.log("Full Response:", response);
        console.log("Response Status:", response.status);
        console.log("Response Data:", response.data);
        
        obj.isLoading = false;
        
        if (response.data ) {
          console.log("Houses found:", response.data.length);
          obj.recommendedHouses = response.data;
          
          // Only call getSentence if we have houses
          if (obj.recommendedHouses.length > 0) {
            obj.recommendedHouses.forEach((house) => {
              obj.getSentence(obj, house.houseLetId);
            });
          } else {
            console.log("No houses found in the response");
          }
        } else {
          console.error("Invalid response structure:", response.data);
          obj.recommendedHouses = [];
        }
      })
      .catch(function (error) {
        console.error("=== API ERROR ===");
        console.error("Error details:", error);
        console.error("Error response:", error.response);
        console.error("Error status:", error.response?.status);
        console.error("Error data:", error.response?.data);
        
        obj.isLoading = false;
        
        // Set error message
        if (error.code === 'ECONNABORTED') {
          obj.searchError = "Request timed out. Please try again.";
        } else if (error.response?.status === 404) {
          obj.searchError = "Search endpoint not found. Backend might not be running.";
        } else if (error.response?.status >= 500) {
          obj.searchError = "Server error. Please try again later.";
        } else {
          obj.searchError = "Failed to connect to server. Please check if backend is running.";
        }
        
        // Set empty results on error
        obj.recommendedHouses = [];
      });
    },

    // Advanced Filter Methods
    toggleFilterDropdown() {
      this.isFilterDropdownOpen = !this.isFilterDropdownOpen;
    },

    handleClickOutside(event) {
      const sac = this.$el.querySelector('.search-autocomplete-wrap');
      if (this.searchSuggestionsOpen && sac && !sac.contains(event.target)) {
        this.searchSuggestionsOpen = false;
      }

      // Check if click is outside the filter button and dropdown
      const filterButton = this.$el.querySelector('.logo-button');
      const dropdown = this.$el.querySelector('.filter-dropdown-menu');
      
      if (this.isFilterDropdownOpen && 
          filterButton && 
          !filterButton.contains(event.target) && 
          dropdown && 
          !dropdown.contains(event.target)) {
        this.isFilterDropdownOpen = false;
      }
    },

    setActiveFilterTab(index) {
      this.activeFilterTab = index;
    },

    // District Tab Methods
    selectRegion(region) {
      this.selectedRegion = region;
      this.selectedDistrict = '';
      this.selectedArea = 'ALL AREAS';
      this.selectedAreas = [];
    },

    selectDistrict(district) {
      this.selectedDistrict = district;
      this.selectedArea = 'ALL AREAS';
      this.selectedAreas = [];
    },

    selectArea(area) {
      if (this.selectedAreas.includes(area)) {
        this.selectedAreas = this.selectedAreas.filter((item) => item !== area);
      } else {
        this.selectedAreas = [...this.selectedAreas, area];
      }
      this.selectedArea = this.selectedAreas[0] || 'ALL AREAS';
    },

    locationPickKey(p) {
      const n = this.normalizePick(p);
      if (!n || !n.region) return '';
      const a = (n.areas || []).slice().sort().join('\u0001');
      return `${n.region}\u0000${n.district || ''}\u0000${a}`;
    },

    normalizePick(p) {
      if (!p || !p.region) return null;
      const areas = Array.isArray(p.areas) ? p.areas.filter((x) => x && x !== 'ALL AREAS') : [];
      return {
        region: p.region,
        district: p.district || '',
        areas: areas.length ? areas : null
      };
    },

    draftLocationPick() {
      if (!this.selectedRegion) return null;
      const areas = (this.selectedAreas || []).filter((a) => a && a !== 'ALL AREAS');
      if (this.selectedDistrict) {
        if (areas.length > 0) {
          return { region: this.selectedRegion, district: this.selectedDistrict, areas: [...areas] };
        }
        return { region: this.selectedRegion, district: this.selectedDistrict, areas: null };
      }
      return { region: this.selectedRegion, district: '', areas: null };
    },

    collectCommittedLocationPicks() {
      const merged = [];
      const seen = new Set();
      (this.selectedLocations || []).forEach((p) => {
        const n = this.normalizePick(p);
        if (!n) return;
        const k = this.locationPickKey(n);
        if (seen.has(k)) return;
        seen.add(k);
        merged.push(n);
      });
      return merged;
    },

    /** Chips only for API — draft picker is applied via legacy selectedRegion/District/Area fields unless user adds chips. */
    collectLocationPicksForSearch() {
      const merged = this.collectCommittedLocationPicks();
      const draft = this.draftLocationPick();
      const draftNorm = draft ? this.normalizePick(draft) : null;
      if (!draftNorm) {
        return merged;
      }
      const kDraft = this.locationPickKey(draftNorm);
      if (!kDraft) {
        return merged;
      }
      const seen = new Set(merged.map((p) => this.locationPickKey(p)));
      if (seen.has(kDraft)) {
        return merged;
      }
      return [...merged, draftNorm];
    },

    serializeLocationPicksForApi() {
      return this.collectCommittedLocationPicks().map((p) => ({
        region: p.region,
        district: p.district && p.district.length ? p.district : null,
        areas: p.areas && p.areas.length ? p.areas : null
      }));
    },

    addCurrentLocationToList() {
      const d = this.draftLocationPick();
      if (!d) return;
      const list = Array.isArray(this.selectedLocations) ? [...this.selectedLocations] : [];
      const k = this.locationPickKey(d);
      for (let i = 0; i < list.length; i++) {
        if (this.locationPickKey(this.normalizePick(list[i])) === k) {
          return;
        }
      }
      list.push({
        region: d.region,
        district: d.district && d.district.length ? d.district : null,
        areas: d.areas && d.areas.length ? [...d.areas] : null
      });
      this.selectedLocations = list;
    },

    removeLocationPick(index) {
      this.selectedLocations = (this.selectedLocations || []).filter((_, i) => i !== index);
    },

    locationPickLabel(pick) {
      const p = this.normalizePick(pick);
      if (!p) return '';
      if (!p.district) return p.region;
      if (!p.areas || !p.areas.length) return `${p.region} · ${p.district}`;
      if (p.areas.length === 1) return `${p.district} — ${p.areas[0]}`;
      return `${p.district} — ${p.areas.length} areas`;
    },

    // MTR Tab Methods
    selectMTRLine(line) {
      this.selectedMTRLine = line;
      this.selectedMTRStation = '';
      this.selectedMTRDistance = 'ALL DISTANCES';
    },

    selectMTRStation(station) {
      this.selectedMTRStation = station;
      this.selectedMTRDistance = 'ALL DISTANCES';
    },

    selectMTRDistance(distance) {
      this.selectedMTRDistance = distance;
    },

    // University Tab Methods
    selectUniversity(university) {
      this.selectedUniversity = university;
      this.selectedUniversityDistance = '';
      this.selectedUniversityTransport = 'ALL TRANSPORT';
    },

    selectUniversityDistance(distance) {
      this.selectedUniversityDistance = distance;
      this.selectedUniversityTransport = 'ALL TRANSPORT';
    },

    selectUniversityTransport(transport) {
      this.selectedUniversityTransport = transport;
    },

    // Leasing Company Tab Methods
    selectCompany(company) {
      this.selectedCompany = company;
      this.selectedCompanyType = '';
      this.selectedCompanyRating = 'ALL RATINGS';
    },

    selectCompanyType(type) {
      this.selectedCompanyType = type;
      this.selectedCompanyRating = 'ALL RATINGS';
    },

    selectCompanyRating(rating) {
      this.selectedCompanyRating = rating;
    },

    resetAdvancedFilters() {
      // Reset all selections
      this.selectedRegion = '';
      this.selectedDistrict = '';
      this.selectedArea = 'ALL AREAS';
      this.selectedAreas = [];
      this.selectedLocations = [];
      this.selectedMTRLine = '';
      this.selectedMTRStation = '';
      this.selectedMTRDistance = 'ALL DISTANCES';
      this.selectedUniversity = '';
      this.selectedUniversityDistance = '';
      this.selectedUniversityTransport = 'ALL TRANSPORT';
      this.selectedCompany = '';
      this.selectedCompanyType = '';
      this.selectedCompanyRating = 'ALL RATINGS';
    },

    applyAdvancedFilters() {
      this.isFilterDropdownOpen = false;
      this.searchit();
    },

  },
};
</script>
